<template>
<transition name="modal">
    <div class="dialog-modal-mask">
        <div class="large-panel" style="min-height: 90vh;margin-top: -45vh;height: auto" @click.stop>
            <div class="dialog-title" v-t="'message.title_client_setting_edit'">
            </div>
            <hr class="dialog-hr">
            <div class="dialog-body-setting">
                <el-form><!--- label-width="250px"--->
                    <table width="100%">
                        <tr>
                            <!--- 設定名 --->
                            <td class="setting-name-1" style="padding-top:10px">
                                <span v-t="'message.item_client_setting_name'"></span> <span class="required" v-t="'message.item_required'"></span>
                            </td>
                            <td colspan="2" class="setting-value">
                                <el-form-item prop="settingName" ref="settingName">
                                    <div v-if="!clientSettingsForEachNode">
                                        <el-tooltip effect="dark" placement="top-start">
                                            <div slot="content" v-t="'message.hint_client_setting_cannot_change_name'"></div>
                                            <el-input id="settingName" size="large" type="text" placeholder="入力してください" v-model="inputItems.settingName.value" :disabled="true"
                                                      @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                                      clearable @clear="inputCheckAll()"/>
                                        </el-tooltip>
                                    </div>
                                    <div v-else>
                                        <el-input id="settingName" size="large" type="text" placeholder="入力してください" v-model="inputItems.settingName.value" :disabled="disabledChange || !clientSettingsForEachNode"
                                                  @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                                  clearable @clear="inputCheckAll()"/>
                                    </div>
                                </el-form-item>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="3" style="padding-left: 20px;padding-bottom:10px">
                                <span v-t="'message.hint_client_setting1'"></span><br>
                                <span style="color: #d55169;" v-t="'message.hint_client_setting2'"></span>
                            </td>
                        </tr>
                        <!--- 共通設定 --->
                        <tr class="object-titlebox" style="display: table-row">
                            <td class="object-titlebox-text" style="width:250px;padding-left:20px;" v-t="'message.title_client_common'"></td>
                            <td class="object-titlebox-text" style="padding-left:20px" v-t="'message.title_client_value'"></td>
                            <td class="setting-switch-header" v-t="'message.title_client_enabling'"></td>
                        </tr>
                        <tr>
                            <!--- 起動時の自動実行 --->
                            <td class="setting-name-1" v-t="'message.item_client_auto_start'">
                            </td>
                            <td class="setting-value" style="padding-top:10px">
                                <el-form-item class="setting-items" ref="formItemAutoStart">
                                    <el-radio-group v-model="inputForm.settingJson.Common.autoStart" @change="handleChangeToggleValue" :disabled="!enableSwitch.autoStart.value || disabledChange">
                                        <el-radio :label="true"><span v-t="'message.value_on'"></span></el-radio>
                                        <el-radio :label="false"><span v-t="'message.value_off'"></span></el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </td>
                            <td class="setting-switch" style="padding-top:10px;">
                                <el-switch class="enableSwitch" v-model="enableSwitch.autoStart.value" active-color="#5171cb" @change="handleChangeToggleSwitch('Common','autoStart',enableSwitch.autoStart.value)" :disabled="disabledChange"></el-switch>
                            </td>
                        </tr>
                        <tr>
                            <!--- サブボタンの動作(右） --->
                            <td class="setting-name-2" v-t="'message.item_client_sub_button_right'">
                            </td>
                            <td class="setting-value">
                                <el-form-item class="setting-items" prop="subButtonMode" ref="subButtonMode">
                                    <el-select v-model="inputItems.subButtonMode.value" ref="subButtonMode" v-on:change="handleChangeItems('subButtonMode')" :disabled="!inputItems.subButtonMode.enable || disabledChange" :placeholder="$t('message.place_holder_select_item')">
                                        <el-option v-for="item in subButtonTypes" :key="item.value" :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </td>
                            <td class="setting-switch">
                                <el-switch class="enableSwitch" v-model="inputItems.subButtonMode.enable" active-color="#5171cb" @change="handleChangeItems('subButtonMode')" :disabled="disabledChange"></el-switch>
                            </td>
                        </tr>
                        <tr>
                            <!--- サブボタンの動作(左） --->
                            <td class="setting-name-2" v-t="'message.item_client_sub_button_left'">
                            </td>
                            <td class="setting-value">
                                <el-form-item class="setting-items" prop="subButtonLeftMode" ref="subButtonLeftMode">
                                    <el-select v-model="inputItems.subButtonLeftMode.value" ref="subButtonLeftMode" v-on:change="handleChangeItems('subButtonLeftMode')" :disabled="!inputItems.subButtonLeftMode.enable || disabledChange" :placeholder="$t('message.place_holder_select_item')">
                                        <el-option v-for="item in subButtonTypes" :key="item.value" :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </td>
                            <td class="setting-switch">
                                <el-switch class="enableSwitch" v-model="inputItems.subButtonLeftMode.enable" active-color="#5171cb" @change="handleChangeItems('subButtonLeftMode')" :disabled="disabledChange"></el-switch>
                            </td>
                        </tr>
                        <tr>
                            <!--- カスタムURLスキーム for iOS--->
                            <td class="setting-name-2" v-t="'message.item_client_url_scheme_iOS'">
                            </td>
                            <td class="setting-value">
                                <el-form-item prop="customURL" ref="customURL">
                                    <el-input id="customURL" :placeholder="$t('message.place_holder_input_text')" v-model="inputItems.customURL.value" :disabled="!inputItems.customURL.enable || disabledChange"
                                         @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                         clearable @clear="inputCheckAll()"/>
                                </el-form-item>
                            </td>
                            <td class="setting-switch">
                                <el-switch class="enableSwitch" v-model="inputItems.customURL.enable" active-color="#5171cb" @change="handleChangeItems('customURL')" :disabled="disabledChange"></el-switch>
                            </td>
                        </tr>
                        <tr>
                            <!--- カスタムURLスキーム for Android--->
                            <td class="setting-name-2" style="padding-top:30px" v-t="'message.item_client_url_scheme_android'">
                            </td>
                            <td class="setting-value">
                                <el-form-item prop="customURLPackageName" ref="customURLPackageName">
                                    <el-input id="customURLPackageName" class="custom-url" :placeholder="$t('message.place_holder_input_text')" v-model="inputItems.customURLAndroid.value1" :disabled="!inputItems.customURLAndroid.enable || disabledChange"
                                         @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheckCustomURLAndroid($event.target.id)"
                                         clearable @clear="inputCheckAll()">
                                         <template slot="prepend"><span v-t="'message.item_client_url_scheme_package'"/></template>
                                    </el-input>
                                </el-form-item>
                                <el-form-item prop="customURLClassName" ref="customURLClassName">
                                    <el-input id="customURLClassName" class="custom-url" :placeholder="$t('message.place_holder_input_text')" v-model="inputItems.customURLAndroid.value2" :disabled="!inputItems.customURLAndroid.enable || disabledChange"
                                         @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheckCustomURLAndroid($event.target.id)"
                                         clearable @clear="inputCheckAll()">
                                         <template slot="prepend"><span v-t="'message.item_client_url_scheme_class'"/></template>
                                    </el-input>
                                </el-form-item>
                            </td>
                            <td class="setting-switch">
                                <el-switch class="enableSwitch" v-model="inputItems.customURLAndroid.enable" active-color="#5171cb" @change="handleChangeItems('customURLAndroid')" :disabled="disabledChange"></el-switch>
                            </td>
                        </tr>
                        <tr>
                            <!--- バックグラウンドモード（iOSのみ） --->
                            <td class="setting-name-2" v-t="'message.item_client_ios_audio_mode'">
                            </td>
                            <td class="setting-value">
                                <el-form-item class="setting-items" ref="formIosAudioMode">
                                    <el-radio-group v-model="inputForm.settingJson.Common.iOSAudioMode" @change="handleChangeToggleValue" :disabled="!enableSwitch.iOSAudioMode.value || disabledChange">
                                        <el-radio :label="true"><span v-t="'message.value_on'"/></el-radio>
                                        <el-radio :label="false"><span v-t="'message.value_off'"/></el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </td>
                            <td class="setting-switch" style="padding-top:10px;">
                                <el-switch class="enableSwitch" v-model="enableSwitch.iOSAudioMode.value" active-color="#5171cb" @change="handleChangeToggleSwitch('Common','iOSAudioMode',enableSwitch.iOSAudioMode.value)" :disabled="disabledChange"></el-switch>
                            </td>
                        </tr>
                        <tr>
                            <!--- 画面をSleepにしない（Androidのみ） --->
                            <td class="setting-name-2" v-t="'message.item_client_stay_awake'">
                            </td>
                            <td class="setting-value">
                                <el-form-item class="setting-items" ref="formStayAwake">
                                    <el-radio-group v-model="inputForm.settingJson.Common.stayAwake" @change="handleChangeToggleValue" :disabled="!enableSwitch.stayAwake.value || disabledChange">
                                        <el-radio :label="true"><span v-t="'message.value_on'"/></el-radio>
                                        <el-radio :label="false"><span v-t="'message.value_off'"/></el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </td>
                            <td class="setting-switch" style="padding-top:10px;">
                                <el-switch class="enableSwitch" v-model="enableSwitch.stayAwake.value" active-color="#5171cb" @change="handleChangeToggleSwitch('Common','stayAwake',enableSwitch.stayAwake.value)" :disabled="disabledChange"></el-switch>
                            </td>
                        </tr>
                        <!--- 定型文 --->
                        <tr v-for="(fixedPhraseItemName, fixedPhraseIndex) in fixedPhraseItemList" class="setting-item-record">
                            <td v-if="(fixedPhraseIndex % 2) === 0" class="setting-name-2" v-t="{ path: 'message.item_client_fixPhraseTitle', args: { number: Math.floor(fixedPhraseIndex/2) + 1 } }"></td>
                            <td v-else class="setting-name-2" v-t="{ path: 'message.item_client_fixPhrase', args: { number: Math.floor(fixedPhraseIndex/2) + 1 } }"></td>
                            <td v-if="(fixedPhraseIndex % 2) === 0" class="setting-value">
                                <el-form-item :prop="fixedPhraseItemName" :ref="fixedPhraseItemName">
                                    <el-input :id="fixedPhraseItemName" class="custom-url" :placeholder="$t('message.place_holder_input_text')" v-model="inputItems[fixedPhraseItemName].value" :disabled="!inputItems[fixedPhraseItemName].enable || disabledChange"
                                              @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                              clearable @clear="inputCheckAll()">
                                    </el-input>
                                </el-form-item>
                            </td>
                            <td v-else class="setting-value">
                                <EditClientSettingFixedPhrase :ref="fixedPhraseItemName" :fixedPhraseItem="fixedPhraseItem" :fixedPhraseName="fixedPhraseItemName" :fixedPhraseValue="inputItems[fixedPhraseItemName].value"
                                                              :enableSwitchValue="inputItems[fixedPhraseItemName].enable"
                                                              @setSaveButtonStatus="setValidStatusOfFixedPhrase">
                                </EditClientSettingFixedPhrase>
                            </td>
                            <td class="setting-switch" style="padding-top:10px;">
                                <el-switch class="enableSwitch" v-model="inputItems[fixedPhraseItemName].enable" active-color="#5171cb" @change="handleChangeItems(fixedPhraseItemName)" :disabled="disabledChange"></el-switch>
                            </td>
                        </tr>
                        <template v-if="enableSafetySupport">
                            <tr>
                                <!--- ボイスレポート開始時に通知メッセージを読み上げる --->
                                <td class="setting-name-1" v-t="'message.title_client_voice_report_read_aloud'">
                                </td>
                                <td class="setting-value" style="padding-top:10px">
                                    <el-form-item class="setting-items" ref="formItemvoiceReportEnableNotify">
                                        <el-radio-group v-model="inputForm.settingJson.Common.voiceReportEnableNotify" @change="handleChangeToggleValue" :disabled="!enableSwitch.voiceReportEnableNotify.value || disabledChange">
                                            <el-radio :label="true"><span v-t="'message.value_on'"></span></el-radio>
                                            <el-radio :label="false"><span v-t="'message.value_off'"></span></el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                </td>
                                <td class="setting-switch" style="padding-top:10px;">
                                    <el-switch class="enableSwitch" v-model="enableSwitch.voiceReportEnableNotify.value" active-color="#5171cb" @change="handleChangeToggleSwitch('Common','voiceReportEnableNotify', enableSwitch.voiceReportEnableNotify.value)" :disabled="disabledChange"></el-switch>
                                </td>
                            </tr>
                            <tr>
                                <!--- ボイスレポート開始時に通知パネルを表示する --->
                                <td class="setting-name-1" v-t="'message.title_client_voice_report_show_popup'">
                                </td>
                                <td class="setting-value" style="padding-top:10px">
                                    <el-form-item class="setting-items" ref="formItemVoiceReportShowPopup">
                                        <el-radio-group v-model="inputForm.settingJson.Common.voiceReportShowPopup" @change="handleChangeToggleValue" :disabled="!enableSwitch.voiceReportShowPopup.value || disabledChange">
                                            <el-radio :label="true"><span v-t="'message.value_on'"></span></el-radio>
                                            <el-radio :label="false"><span v-t="'message.value_off'"></span></el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                </td>
                                <td class="setting-switch" style="padding-top:10px;">
                                    <el-switch class="enableSwitch" v-model="enableSwitch.voiceReportShowPopup.value" active-color="#5171cb" @change="handleChangeToggleSwitch('Common','voiceReportShowPopup', enableSwitch.voiceReportShowPopup.value)" :disabled="disabledChange"></el-switch>
                                </td>
                            </tr>
                            <tr>
                                <!--- ボイスレポート開始時の通知メッセージ --->
                                <td class="setting-name-1">
                                    <span v-t="'message.title_client_voice_report_message'"></span>
                                    <el-tooltip effect="dark" placement="top-start">
                                        <div slot="content" style="text-align:left"
                                             v-html="$t('message.hint_voice_report_message')"></div>
                                        <img class="icon-help" :src="require('@/assets/icon_help.svg')" alt="" />
                                    </el-tooltip>
                                </td>
                                <td class="setting-value" style="padding-top:10px">
                                    <el-form-item class="setting-items" ref="voiceReportNotifyMessage">
                                        <el-input type="textarea" v-model="inputItems.voiceReportNotifyMessage.value" @input="handleInputText('voiceReportNotifyMessage')" :placeholder="$t('message.place_holder_input_text')" :rows="1" :disabled="!inputItems.voiceReportNotifyMessage.enable || disabledChange" clearable />
                                    </el-form-item>
                                </td>
                                <td class="setting-switch" style="padding-top:10px;">
                                    <el-switch class="enableSwitch" v-model="inputItems.voiceReportNotifyMessage.enable" active-color="#5171cb" @change="handleInputText('voiceReportNotifyMessage')" :disabled="disabledChange"></el-switch>
                                </td>
                            </tr>
                            <tr>
                                <!--- ボイスレポート開始時に音声をきく --->
                                <td class="setting-name-1" v-t="'message.title_client_voice_report_listen_by_default'">
                                </td>
                                <td class="setting-value" style="padding-top:10px">
                                    <el-form-item class="setting-items" ref="formItemvoiceReportSubscribeByDefault">
                                        <el-radio-group v-model="inputForm.settingJson.Common.voiceReportSubscribeByDefault" @change="handleChangeToggleValue" :disabled="!enableSwitch.voiceReportSubscribeByDefault.value || disabledChange">
                                            <el-radio :label="true"><span v-t="'message.value_on'"></span></el-radio>
                                            <el-radio :label="false"><span v-t="'message.value_off'"></span></el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                </td>
                                <td class="setting-switch" style="padding-top:10px;">
                                    <el-switch class="enableSwitch" v-model="enableSwitch.voiceReportSubscribeByDefault.value" active-color="#5171cb" @change="handleChangeToggleSwitch('Common','voiceReportSubscribeByDefault', enableSwitch.voiceReportSubscribeByDefault.value)" :disabled="disabledChange"></el-switch>
                                </td>
                            </tr>
                        </template>
                        <tr>
                            <!--- Wi-Fi/モバイル通信の優先設定（Android）--->
                            <td class="setting-name-2" v-t="'message.item_client_preferred_network_android'">
                            </td>
                            <td class="setting-value">
                                <el-form-item class="setting-items" prop="preferredNetworkAndroid" ref="preferredNetworkAndroid">
                                    <el-select v-model="inputItems.preferredNetworkAndroid.value" ref="preferredNetworkAndroid" v-on:change="handleChangeItems('preferredNetworkAndroid')" :disabled="!inputItems.preferredNetworkAndroid.enable || disabledChange" :placeholder="$t('message.place_holder_select_item')">
                                        <el-option v-for="item in preferredNetworkAndroidTypes" :key="item.value" :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </td>
                            <td class="setting-switch">
                                <el-switch class="enableSwitch" v-model="inputItems.preferredNetworkAndroid.enable" active-color="#5171cb" @change="handleChangeItems('preferredNetworkAndroid')" :disabled="disabledChange"></el-switch>
                            </td>
                        </tr>
                        <tr>
                            <!--- Wi-Fi/モバイル通信の優先設定（iOS）--->
                            <td class="setting-name-2" v-t="'message.item_client_preferred_network_ios'">
                            </td>
                            <td class="setting-value">
                                <el-form-item class="setting-items" prop="preferredNetworkIOS" ref="preferredNetworkIOS">
                                    <el-select v-model="inputItems.preferredNetworkIOS.value" ref="preferredNetworkIOS" v-on:change="handleChangeItems('preferredNetworkIOS')" :disabled="!inputItems.preferredNetworkIOS.enable || disabledChange" :placeholder="$t('message.place_holder_select_item')">
                                        <el-option v-for="item in preferredNetworkIOSTypes" :key="item.value" :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </td>
                            <td class="setting-switch">
                                <el-switch class="enableSwitch" v-model="inputItems.preferredNetworkIOS.enable" active-color="#5171cb" @change="handleChangeItems('preferredNetworkIOS')" :disabled="disabledChange"></el-switch>
                            </td>
                        </tr>
                        <!--- トーク設定 --->
                        <tr class="object-titlebox" style="display: table-row">
                            <td class="object-titlebox-text" style="width:250px;padding-left:20px;" v-t="'message.title_client_talk'"></td>
                            <td class="object-titlebox-text" style="padding-left:20px" v-t="'message.title_client_value'"></td>
                            <td class="setting-switch-header" v-t="'message.title_client_enabling'"></td>
                        </tr>
                        <tr>
                            <!--- 画面ボタンの動作 --->
                            <td class="setting-name-2" style="padding-top:20px" v-t="'message.item_client_main_button'">
                            </td>
                            <td class="setting-value" style="padding-top:10px">
                                <el-form-item class="setting-items" ref="formItemButtonMode" style="width: 750px">
                                    <el-radio-group v-model="inputForm.settingJson.Talk.buttonMode" fill="#5171cb" @change="handleChangeToggleValue()" :disabled="!enableSwitch.buttonMode.value || disabledChange">
                                        <el-radio :label="false"><span v-t="'message.value_hold'"/></el-radio>
                                        <el-radio :label="true"><span v-t="'message.value_toggle'"/></el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </td>
                            <td class="setting-switch" style="padding-top:10px;">
                                <el-switch class="enableSwitch" v-model="enableSwitch.buttonMode.value" active-color="#5171cb" @change="handleChangeToggleSwitch('Talk','buttonMode',enableSwitch.buttonMode.value)" :disabled="disabledChange"></el-switch>
                            </td>
                        </tr>
                        <tr>
                            <!--- 外部ボタンの動作 --->
                            <td class="setting-name-2" v-t="'message.item_client_ble_button'">
                            </td>
                            <td class="setting-value">
                                <el-form-item class="setting-items" ref="formItemBleButtonMode" style="width: 750px">
                                    <el-radio-group v-model="inputForm.settingJson.Talk.bleButtonMode" fill="#5171cb" @change="handleChangeToggleValue" :disabled="!enableSwitch.bleButtonMode.value || disabledChange">
                                        <el-radio :label="false"><span v-t="'message.value_hold'"/></el-radio>
                                        <el-radio :label="true"><span v-t="'message.value_toggle'"/></el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </td>
                            <td class="setting-switch" style="padding-top:10px;">
                                <el-switch class="enableSwitch" v-model="enableSwitch.bleButtonMode.value" active-color="#5171cb" @change="handleChangeToggleSwitch('Talk','bleButtonMode',enableSwitch.bleButtonMode.value)" :disabled="disabledChange"></el-switch>
                            </td>
                        </tr>
                        <tr>
                            <!--- ミニトークボタンの動作 --->
                            <td class="setting-name-2" v-t="'message.item_client_mini_talk_button'">
                            </td>
                            <td class="setting-value">
                                <el-form-item class="setting-items" ref="formItemMiniTalkButtonMode" style="width: 750px">
                                    <el-radio-group v-model="inputForm.settingJson.Talk.miniTalkButtonMode" fill="#5171cb" @change="handleChangeToggleValue" :disabled="!enableSwitch.miniTalkButtonMode.value || disabledChange">
                                        <el-radio :label="false"><span v-t="'message.value_hold'"/></el-radio>
                                        <el-radio :label="true"><span v-t="'message.value_toggle'"/></el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </td>
                            <td class="setting-switch" style="padding-top:10px;">
                                <el-switch class="enableSwitch" v-model="enableSwitch.miniTalkButtonMode.value" active-color="#5171cb" @change="handleChangeToggleSwitch('Talk','miniTalkButtonMode',enableSwitch.miniTalkButtonMode.value)" :disabled="disabledChange"></el-switch>
                            </td>
                        </tr>
                        <!--- Face to Talk --->
                        <tr>
                            <td>
                                <span class="setting-name-2" v-t="'message.item_client_face_to_talk'"></span><br>
                                <span style="padding-left: 20px;padding-bottom:10px;color: #d55169;" v-t="'message.hint_ftt_setting'"></span>
                            </td>
                            <td class="setting-value">
                                <el-form-item class="setting-items" ref="formItemFaceToTalk" style="width: 750px">
                                    <el-radio-group v-model="inputForm.settingJson.Talk.faceToTalkMode" fill="#5171cb" @change="handleChangeToggleFttValue()" :disabled="!enableSwitch.faceToTalkMode.value || disabledChange">
                                        <el-radio :label="true"><span v-t="'message.value_on'"/></el-radio>
                                        <el-radio :label="false"><span v-t="'message.value_off'"/></el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </td>
                            <td class="setting-switch" style="padding-top:10px;">
                                <el-switch class="enableSwitch" v-model="enableSwitch.faceToTalkMode.value" active-color="#5171cb" @change="handleChangeToggleSwitch('Talk','faceToTalkMode',enableSwitch.faceToTalkMode.value)" :disabled="disabledChange"></el-switch>
                            </td>
                        </tr>
                        <!--- echo mode--->
                        <tr>
                            <td class="setting-name-2" v-t="'message.item_client_echo_mode'">
                            </td>
                            <td class="setting-value">
                                <el-form-item class="setting-items" ref="formItemEcho" style="width: 750px">
                                    <el-radio-group v-model="inputForm.settingJson.Talk.echo" fill="#5171cb" @change="handleChangeToggleValue()" :disabled="!enableSwitch.echo.value || disabledChange">
                                        <el-radio :label="true"><span v-t="'message.value_on'"/></el-radio>
                                        <el-radio :label="false"><span v-t="'message.value_off'"/></el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </td>
                            <td class="setting-switch" style="padding-top:10px;">
                                <el-switch class="enableSwitch" v-model="enableSwitch.echo.value" active-color="#5171cb" @change="handleChangeToggleSwitch('Talk','echo',enableSwitch.echo.value)" :disabled="disabledChange"></el-switch>
                            </td>
                        </tr>
                        <!--- vox--->
                        <tr>
                            <td>
                                <span class="setting-name-2" v-t="'message.item_client_vox'"></span><br>
                                <span style="padding-left: 20px;padding-bottom:10px;color: #d55169;" v-t="'message.hint_vox_setting'"></span>
                            </td>
                            <td class="setting-value">
                                <el-form-item class="setting-items" ref="formItemVox" style="width: 750px">
                                    <el-radio-group v-model="inputForm.settingJson.Talk.vox" fill="#5171cb" @change="handleChangeToggleVoxValue()" :disabled="!enableSwitch.vox.value || disabledChange">
                                        <el-radio :label="true"><span v-t="'message.value_on'"/></el-radio>
                                        <el-radio :label="false"><span v-t="'message.value_off'"/></el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </td>
                            <td class="setting-switch" style="padding-top:10px;">
                                <el-switch class="enableSwitch" v-model="enableSwitch.vox.value" active-color="#5171cb" @change="handleChangeToggleSwitch('Talk','vox',enableSwitch.vox.value)" :disabled="disabledChange"></el-switch>
                            </td>
                        </tr>
                        <!-- 遅延音声カットモード -->
                        <tr v-if="enableVoiceDelay">
                            <td class="setting-name-2">
                                <span v-t="'message.item_client_cut_voice_delay'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left"
                                         v-html="$t('message.hint_client_cut_voice_delay')"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')" alt="" />
                                </el-tooltip>
                            </td>
                            <td class="setting-value">
                                <el-form-item class="setting-items" prop="cutVoiceDelayQueueSeconds" ref="cutVoiceDelayQueueSeconds">
                                    <el-select v-model="inputItems.cutVoiceDelayQueueSeconds.value" v-on:change="handleChangeItems('cutVoiceDelayQueueSeconds')" :disabled="!inputItems.cutVoiceDelayQueueSeconds.enable || disabledChange" :placeholder="$t('message.place_holder_select_item')">
                                        <el-option v-for="item in cutVoiceDelayQueueSecondsTypes" :key="item.value" :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </td>
                            <td class="setting-switch">
                                <el-switch class="enableSwitch" v-model="inputItems.cutVoiceDelayQueueSeconds.enable" active-color="#5171cb" @change="handleChangeItems('cutVoiceDelayQueueSeconds')" :disabled="disabledChange"></el-switch>
                            </td>
                        </tr>
                        <!--- マイクを常時オンにする --->
                        <tr>
                            <td>
                                <span class="setting-name-2" v-t="'message.item_client_background_mic'"></span><br>
                                <span style="padding-left: 20px;padding-bottom:10px;color: #d55169;" v-t="'message.hint_background_mic_setting'"></span>
                            </td>
                            <td class="setting-value">
                                <el-form-item class="setting-items" ref="formItemBackgroundMic" style="width: 750px">
                                    <el-radio-group v-model="inputForm.settingJson.Talk.backgroundMic" fill="#5171cb" @change="handleChangeToggleValue()" :disabled="!enableSwitch.backgroundMic.value || disabledChange">
                                        <el-radio :label="true"><span v-t="'message.value_on'"/></el-radio>
                                        <el-radio :label="false"><span v-t="'message.value_off'"/></el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </td>
                            <td class="setting-switch" style="padding-top:10px;">
                                <el-switch class="enableSwitch" v-model="enableSwitch.backgroundMic.value" active-color="#5171cb" @change="handleChangeToggleSwitch('Talk','backgroundMic',enableSwitch.backgroundMic.value)" :disabled="disabledChange"></el-switch>
                            </td>
                        </tr>
                        <!-- 音声処理モード -->
                        <tr>
                            <td class="setting-name-2" v-t="'message.item_client_voice_processing'">
                            </td>
                            <td class="setting-value">
                                <el-form-item class="setting-items" ref="formItemVoiceProcessing" style="width: 750px">
                                    <el-radio-group v-model="inputForm.settingJson.Talk.voiceProcessing" fill="#5171cb" @change="handleChangeToggleValue()" :disabled="!enableSwitch.voiceProcessing.value || disabledChange">
                                        <el-radio :label="true"><span v-t="'message.value_on'"/></el-radio>
                                        <el-radio :label="false"><span v-t="'message.value_off'"/></el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </td>
                            <td class="setting-switch" style="padding-top:10px;">
                                <el-switch class="enableSwitch" v-model="enableSwitch.voiceProcessing.value" active-color="#5171cb" @change="handleChangeToggleSwitch('Talk','voiceProcessing',enableSwitch.voiceProcessing.value)" :disabled="disabledChange"></el-switch>
                            </td>
                        </tr>
                        <!--- チャット設定 --->
                        <tr class="object-titlebox" style="display: table-row">
                            <td class="object-titlebox-text" style="width:250px;padding-left:20px;" v-t="'message.title_client_chat'"></td>
                            <td class="object-titlebox-text" style="padding-left:20px" v-t="'message.title_client_value'"></td>
                            <td class="setting-switch-header" v-t="'message.title_client_enabling'"></td>
                        </tr>
                        <tr>
                            <!--- 翻訳結果の自動読み上げ --->
                            <td class="setting-name-2" style="padding-top:20px" v-t="'message.item_client_speak'">
                            </td>
                            <td class="setting-value" style="padding-top:10px">
                                <el-form-item class="setting-items" ref="formItemAutoSpeak">
                                    <el-radio-group v-model="inputForm.settingJson.Chat.autoSpeak" fill="#5171cb" @change="handleChangeToggleValue" :disabled="!enableSwitch.autoSpeak.value || disabledChange">
                                        <el-radio :label="true"><span v-t="'message.value_on'"/></el-radio>
                                        <el-radio :label="false"><span v-t="'message.value_off'"/></el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </td>
                            <td class="setting-switch">
                                <el-switch class="enableSwitch" v-model="enableSwitch.autoSpeak.value" active-color="#5171cb" @change="handleChangeToggleSwitch('Chat','autoSpeak',enableSwitch.autoSpeak.value)" :disabled="disabledChange"></el-switch>
                            </td>
                        </tr>
                        <tr>
                            <!--- テキスト受信時の自動読み上げ --->
                            <td class="setting-name-2" v-t="'message.item_client_speakText'">
                            </td>
                            <td class="setting-value">
                                <el-form-item class="setting-items" ref="formItemAutoSpeakText">
                                    <el-radio-group v-model="inputForm.settingJson.Chat.autoSpeakText" fill="#5171cb" @change="handleChangeToggleValue" :disabled="!enableSwitch.autoSpeakText.value || disabledChange">
                                        <el-radio :label="true"><span v-t="'message.value_on'"/></el-radio>
                                        <el-radio :label="false"><span v-t="'message.value_off'"/></el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </td>
                            <td class="setting-switch">
                            <el-switch class="enableSwitch" v-model="enableSwitch.autoSpeakText.value" active-color="#5171cb" @change="handleChangeToggleSwitch('Chat','autoSpeakText',enableSwitch.autoSpeakText.value)" :disabled="disabledChange"></el-switch>
                            </td>
                        </tr>
                        <tr>
                            <!--- 読み上げ対象のグループ --->
                            <td class="setting-name-2" v-t="'message.item_client_chatSubscribeMode'">
                            </td>
                            <td class="setting-value">
                                <el-form-item class="setting-items" ref="formItemChatSubscribeMode">
                                    <el-radio-group v-model="inputForm.settingJson.Chat.chatSubscribeMode" fill="#5171cb" @change="handleChangeToggleValue" :disabled="!enableSwitch.chatSubscribeMode.value || disabledChange">
                                        <el-radio :label="false"><span v-t="'message.item_client_chatSubscribe_talk'"/></el-radio>
                                        <el-radio :label="true"><span v-t="'message.item_client_chatSubscribe_both'"/></el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </td>
                            <td class="setting-switch">
                                <el-switch class="enableSwitch" v-model="enableSwitch.chatSubscribeMode.value" active-color="#5171cb" @change="handleChangeToggleSwitch('Chat','chatSubscribeMode',enableSwitch.chatSubscribeMode.value)" :disabled="disabledChange"></el-switch>
                            </td>
                        </tr>
                        <tr>
                            <!--- 撮影時に送信確認画面を表示(Androidのみ） --->
                            <td class="setting-name-2" v-t="'message.item_client_camera_preview'">
                            </td>
                            <td class="setting-value">
                                <el-form-item class="setting-items" ref="formItemCameraPreview">
                                    <el-radio-group v-model="inputForm.settingJson.Chat.cameraPreview" fill="#5171cb" @change="handleChangeToggleValue" :disabled="!enableSwitch.cameraPreview.value || disabledChange">
                                        <el-radio :label="true"><span v-t="'message.value_on'"/></el-radio>
                                        <el-radio :label="false"><span v-t="'message.value_off'"/></el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </td>
                            <td class="setting-switch">
                                <el-switch class="enableSwitch" v-model="enableSwitch.cameraPreview.value" active-color="#5171cb" @change="handleChangeToggleSwitch('Chat','cameraPreview',enableSwitch.cameraPreview.value)" :disabled="disabledChange"></el-switch>
                            </td>
                        </tr>
                        <!--- ライブキャスト設定 --->
                        <tr class="object-titlebox" style="display: table-row">
                            <td class="object-titlebox-text" style="width:250px;padding-left:20px;" v-t="'message.title_client_video'"></td>
                            <td class="object-titlebox-text" style="padding-left:20px" v-t="'message.title_client_value'"></td>
                            <td class="setting-switch-header" v-t="'message.title_client_enabling'"></td>
                        </tr>
                        <tr>
                            <!--- 解像度とフレームレート --->
                            <td class="setting-name-2" style="padding-top:20px" v-t="'message.item_client_resolution'">
                            </td>
                            <td class="setting-value" style="padding-top:10px">
                                <el-form-item prop="resolution" ref="resolution">
                                    <el-select v-model="inputItems.resolution.value" v-on:change="handleChangeItems('resolution')" :disabled="!inputItems.resolution.enable || disabledChange"  :placeholder="$t('message.place_holder_select_item')">
                                        <el-option v-for="item in resolutionTypes" :key="item.value" :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </td>
                            <td class="setting-switch" style="padding-top:10px">
                                <el-switch class="enableSwitch" v-model="inputItems.resolution.enable" active-color="#5171cb" @change="handleChangeItems('resolution')" :disabled="disabledChange"></el-switch>
                            </td>
                        </tr>
                        <!--- マップ設定 --->
                        <tr class="object-titlebox" style="display: table-row">
                            <td class="object-titlebox-text" style="width:250px;padding-left:20px;" v-t="'message.title_client_map'"></td>
                            <td class="object-titlebox-text" style="padding-left:20px" v-t="'message.title_client_value'"></td>
                            <td class="setting-switch-header" v-t="'message.title_client_enabling'"></td>
                        </tr>
                        <tr>
                            <!--- 現在地の取得 --->
                            <td class="setting-name-2" style="padding-top:20px" v-t="'message.item_client_location_acquire'">
                            </td>
                            <td class="setting-value" style="padding-top:10px">
                                <el-form-item class="setting-items" ref="formItemLocationAcquire">
                                    <el-radio-group v-model="inputForm.settingJson.Common.locationAcquire" fill="#5171cb" @change="handleChangeToggleValue" :disabled="!enableSwitch.locationAcquire.value || disabledChange">
                                        <el-radio :label="true"><span v-t="'message.value_on'"/></el-radio>
                                        <el-radio :label="false"><span v-t="'message.value_off'"/></el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </td>
                            <td class="setting-switch">
                                <el-switch class="enableSwitch" v-model="enableSwitch.locationAcquire.value" active-color="#5171cb" @change="handleChangeToggleSwitch('Common','locationAcquire',enableSwitch.locationAcquire.value)" :disabled="disabledChange"></el-switch>
                            </td>
                        </tr>
                        <tr>
                            <!--- 位置情報の送信 --->
                            <td class="setting-name-2" v-t="'message.item_client_location'">
                            </td>
                            <td class="setting-value">
                                <el-form-item class="setting-items" ref="formItemLocationUpload">
                                    <el-radio-group v-model="inputForm.settingJson.Common.locationUpload" fill="#5171cb" @change="handleChangeToggleValue" :disabled="!enableSwitch.locationUpload.value || disabledChange">
                                        <el-radio :label="true"><span v-t="'message.value_on'"/></el-radio>
                                        <el-radio :label="false"><span v-t="'message.value_off'"/></el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </td>
                            <td class="setting-switch">
                                <el-switch class="enableSwitch" v-model="enableSwitch.locationUpload.value" active-color="#5171cb" @change="handleChangeToggleSwitch('Common','locationUpload',enableSwitch.locationUpload.value)" :disabled="disabledChange"></el-switch>
                            </td>
                        </tr>
                        <tr>
                            <!--- 使用するマップコンポーネント（iOSのみ） --->
                            <td class="setting-name-2" v-t="'message.item_client_map_mode'">
                            </td>
                            <td class="setting-value">
                                <el-form-item class="setting-items" ref="formItemMapComponent">
                                    <el-radio-group v-model="inputForm.settingJson.Common.mapMode" fill="#5171cb" @change="handleChangeToggleValue" :disabled="!enableSwitch.mapMode.value || disabledChange">
                                        <el-radio :label="false"><span v-t="'message.item_map_apple'"/></el-radio>
                                        <el-radio :label="true"><span v-t="'message.item_map_google'"/></el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </td>
                            <td class="setting-switch">
                                <el-switch class="enableSwitch" v-model="enableSwitch.mapMode.value" active-color="#5171cb" @change="handleChangeToggleSwitch('Common','mapMode',enableSwitch.mapMode.value)" :disabled="disabledChange"></el-switch>
                            </td>
                        </tr>
                        <tr>
                            <!--- マップのタイプ --->
                            <td class="setting-name-2" v-t="'message.item_client_map_type'">
                            </td>
                            <td class="setting-value">
                                <el-form-item class="setting-items" ref="formItemMapType">
                                    <el-radio-group v-model="inputForm.settingJson.Common.mapType" fill="#5171cb" @change="handleChangeToggleValue" :disabled="!enableSwitch.mapType.value || disabledChange">
                                        <el-radio :label="false"><span v-t="'message.item_normal'"/></el-radio>
                                        <el-radio :label="true"><span v-t="'message.item_map_satellite'"/></el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </td>
                            <td class="setting-switch">
                                <el-switch class="enableSwitch" v-model="enableSwitch.mapType.value" active-color="#5171cb" @change="handleChangeToggleSwitch('Common','mapType',enableSwitch.mapType.value)" :disabled="disabledChange"></el-switch>
                            </td>
                        </tr>
                        <tr>
                            <!--- 位置情報の送信間隔 --->
                            <td class="setting-name-2" v-t="'message.item_client_location_interval'">
                            </td>
                            <td class="setting-value">
                                <el-form-item prop="locationInterval" ref="locationInterval">
                                    <el-select v-model="inputItems.locationInterval.value" v-on:change="handleChangeItems('locationInterval')" :disabled="!inputItems.locationInterval.enable || disabledChange"  :placeholder="$t('message.place_holder_select_item')">
                                        <el-option v-for="item in locationIntervalTypes" :key="item.value" :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </td>
                            <td class="setting-switch">
                                <el-switch class="enableSwitch" v-model="inputItems.locationInterval.enable" active-color="#5171cb" @change="handleChangeItems('locationInterval')" :disabled="disabledChange"></el-switch>
                            </td>
                        </tr>
                        <!--- ボリューム設定 --->
                        <tr class="object-titlebox" style="display: table-row">
                            <td class="object-titlebox-text" style="width:250px;padding-left:20px;" v-t="'message.title_client_sound'"></td>
                            <td class="object-titlebox-text" style="padding-left:20px" v-t="'message.title_client_value'"></td>
                            <td class="setting-switch-header" v-t="'message.title_client_enabling'"></td>
                        </tr>
                        <tr>
                            <!--- 再接続時のアラート音のボリューム --->
                            <td class="setting-name-2" style="padding-top:20px" v-t="'message.item_client_reconnect_alert'">
                            </td>
                            <td class="setting-value" style="padding-top:10px">
                                <el-form-item :class="{'setting-items' : enableSwitch.reconnectSoundVolume.value, 'disable-setting-items' : !enableSwitch.reconnectSoundVolume.value}">
                                    <el-slider style="padding-left:10px;padding-right:10px;" v-model="inputForm.settingJson.Volume.reconnectSoundVolume" @change="handleChangeReconnectVolume" :disabled="!enableSwitch.reconnectSoundVolume.value || disabledChange"></el-slider>
                                </el-form-item>
                            </td>
                            <td class="setting-switch" style="padding-top:10px;">
                                <el-switch class="enableSwitch" v-model="enableSwitch.reconnectSoundVolume.value" active-color="#5171cb" @change="handleChangeReconnectVolume" :disabled="disabledChange"></el-switch>
                            </td>
                        </tr>
                        <tr>
                            <!--- 音量のボリューム --->
                            <td class="setting-name-2" v-t="'message.item_client_voice_level'">
                            </td>
                            <td class="setting-value">
                                <el-form-item  :class="{'setting-items' : enableSwitch.voiceVolume.value, 'disable-setting-items' : !enableSwitch.voiceVolume.value}">
                                    <el-slider style="padding-left:10px;padding-right:10px;" max="200" v-model="inputForm.settingJson.Volume.voiceVolume" @change="handleChangeVolume('voiceVolume')" :disabled="!enableSwitch.voiceVolume.value || disabledChange"></el-slider>
                                </el-form-item>
                            </td>
                            <td class="setting-switch">
                                <el-switch class="enableSwitch" v-model="enableSwitch.voiceVolume.value" active-color="#5171cb" @change="handleChangeVolume('voiceVolume')" :disabled="disabledChange"></el-switch>
                            </td>
                        </tr>
                        <tr>
                            <!--- 電話中の音声のボリューム --->
                            <td class="setting-name-2" v-t="'message.item_client_voice_level_during_call'">
                            </td>
                            <td class="setting-value">
                                <el-form-item  :class="{'setting-items' : enableSwitch.voiceOffHookVolume.value, 'disable-setting-items' : !enableSwitch.voiceOffHookVolume.value}">
                                    <el-slider style="padding-left:10px;padding-right:10px;" max="200" v-model="inputForm.settingJson.Volume.voiceOffHookVolume" @change="handleChangeVolume('voiceOffHookVolume')" :disabled="!enableSwitch.voiceOffHookVolume.value || disabledChange"></el-slider>
                                </el-form-item>
                            </td>
                            <td class="setting-switch">
                                <el-switch class="enableSwitch" v-model="enableSwitch.voiceOffHookVolume.value" active-color="#5171cb" @change="handleChangeVolume('voiceOffHookVolume')" :disabled="disabledChange"></el-switch>
                            </td>
                        </tr>
                        <tr>
                            <!--- マイクのボリューム --->
                            <td class="setting-name-2" v-t="'message.item_client_mic_level'">
                            </td>
                            <td class="setting-value">
                                <el-form-item  :class="{'setting-items' : enableSwitch.micVolume.value, 'disable-setting-items' : !enableSwitch.micVolume.value}">
                                    <el-slider style="padding-left:10px;padding-right:10px;" max="200" v-model="inputForm.settingJson.Volume.micVolume" @change="handleChangeVolume('micVolume')" :disabled="!enableSwitch.micVolume.value || disabledChange"></el-slider>
                                </el-form-item>
                            </td>
                            <td class="setting-switch">
                                <el-switch class="enableSwitch" v-model="enableSwitch.micVolume.value" active-color="#5171cb" @change="handleChangeVolume('micVolume')" :disabled="disabledChange"></el-switch>
                            </td>
                        </tr>
                        <tr>
                            <!--- 操作音のボリューム --->
                            <td class="setting-name-2" v-t="'message.item_client_operation_sound'">
                            </td>
                            <td class="setting-value">
                                <el-form-item  :class="{'setting-items' : enableSwitch.reactionSoundVolume.value, 'disable-setting-items' : !enableSwitch.reactionSoundVolume.value}">
                                    <el-slider style="padding-left:10px;padding-right:10px;" v-model="inputForm.settingJson.Volume.reactionSoundVolume" @change="handleChangeReactionVolume" :disabled="!enableSwitch.reactionSoundVolume.value || disabledChange"></el-slider>
                                </el-form-item>
                            </td>
                            <td class="setting-switch">
                                <el-switch class="enableSwitch" v-model="enableSwitch.reactionSoundVolume.value" active-color="#5171cb" @change="handleChangeReactionVolume" :disabled="disabledChange"></el-switch>
                            </td>
                        </tr>
                        <tr>
                            <!--- 受信時のビープ音のボリューム --->
                            <td class="setting-name-2" v-t="'message.item_client_beep_level'">
                            </td>
                            <td class="setting-value">
                                <el-form-item  :class="{'setting-items' : enableSwitch.receiveBeepVolume.value, 'disable-setting-items' : !enableSwitch.receiveBeepVolume.value}">
                                    <el-slider style="padding-left:10px;padding-right:10px;" v-model="inputForm.settingJson.Volume.receiveBeepVolume" @change="handleChangeVolume('receiveBeepVolume')" :disabled="!enableSwitch.receiveBeepVolume.value || disabledChange"></el-slider>
                                </el-form-item>
                            </td>
                            <td class="setting-switch">
                                <el-switch class="enableSwitch" v-model="enableSwitch.receiveBeepVolume.value" active-color="#5171cb" @change="handleChangeVolume('receiveBeepVolume')" :disabled="disabledChange"></el-switch>
                            </td>
                        </tr>
                        <tr>
                            <!--- 効果音のボリューム --->
                            <td class="setting-name-2" v-t="'message.item_client_effect_level'">
                            </td>
                            <td class="setting-value">
                                <el-form-item  :class="{'setting-items' : enableSwitch.effectSoundVolume.value, 'disable-setting-items' : !enableSwitch.effectSoundVolume.value}">
                                    <el-slider style="padding-left:10px;padding-right:10px;" v-model="inputForm.settingJson.Volume.effectSoundVolume" @change="handleChangeVolume('effectSoundVolume')" :disabled="!enableSwitch.effectSoundVolume.value || disabledChange"></el-slider>
                                </el-form-item>
                            </td>
                            <td class="setting-switch">
                                <el-switch class="enableSwitch" v-model="enableSwitch.effectSoundVolume.value" active-color="#5171cb" @change="handleChangeVolume('effectSoundVolume')" :disabled="disabledChange"></el-switch>
                            </td>
                        </tr>
                        <tr>
                            <!--- 強制起動時のアラート音のボリューム --->
                            <td class="setting-name-2" v-t="'message.item_client_forcedActivation_alert'">
                            </td>
                            <td class="setting-value">
                                <el-form-item :class="{'setting-items' : enableSwitch.alertSoundVolume.value, 'disable-setting-items' : !enableSwitch.alertSoundVolume.value}">
                                    <el-slider style="padding-left:10px;padding-right:10px;" v-model="inputForm.settingJson.Volume.alertSoundVolume" @change="handleChangeAlertSoundVolume" :disabled="!enableSwitch.alertSoundVolume.value || disabledChange"></el-slider>
                                </el-form-item>
                            </td>
                            <td class="setting-switch" style="padding-top:10px;">
                                <el-switch class="enableSwitch" v-model="enableSwitch.alertSoundVolume.value" active-color="#5171cb" @change="handleChangeAlertSoundVolume" :disabled="disabledChange"></el-switch>
                            </td>
                        </tr>
                        <tr>
                            <!--- エコーモードのボリューム --->
                            <td class="setting-name-2" v-t="'message.item_client_echo_mode_volume'">
                            </td>
                            <td class="setting-value">
                                <el-form-item :class="{'setting-items' : enableSwitch.echoSoundVolume.value, 'disable-setting-items' : !enableSwitch.echoSoundVolume.value || disabledChange}">
                                    <el-slider style="padding-left:10px;padding-right:10px;" v-model="inputForm.settingJson.Volume.echoSoundVolume" @change="handleChangeVolume('echoSoundVolume')" :disabled="!enableSwitch.echoSoundVolume.value || disabledChange"></el-slider>
                                </el-form-item>
                            </td>
                            <td class="setting-switch" style="padding-top:10px;">
                                <el-switch class="enableSwitch" v-model="enableSwitch.echoSoundVolume.value" active-color="#5171cb" @change="handleChangeVolume('echoSoundVolume')" :disabled="disabledChange"></el-switch>
                            </td>
                        </tr>
                        <tr>
                            <!--- 発話中のアラート音のボリューム --->
                            <td class="setting-name-2" v-t="'message.item_client_inSpeechAlert_volume'">
                            </td>
                            <td class="setting-value">
                                <el-form-item :class="{'setting-items' : enableSwitch.inSpeechAlertVolume.value, 'disable-setting-items' : !enableSwitch.inSpeechAlertVolume.value}">
                                    <el-slider style="padding-left:10px;padding-right:10px;" v-model="inputForm.settingJson.Volume.inSpeechAlertVolume" @change="handleChangeVolume('inSpeechAlertVolume')" :disabled="!enableSwitch.inSpeechAlertVolume.value || disabledChange"></el-slider>
                                </el-form-item>
                            </td>
                            <td class="setting-switch" style="padding-top:10px;">
                                <el-switch class="enableSwitch" v-model="enableSwitch.inSpeechAlertVolume.value" active-color="#5171cb" @change="handleChangeVolume('inSpeechAlertVolume')" :disabled="disabledChange"></el-switch>
                            </td>
                        </tr>
                        <tr v-if="enableDisconnectAlertGroup()">
                            <!--- 切断通知アラート音のボリューム --->
                            <td class="setting-name-2" v-t="'message.item_client_disconnectAlert_volume'">
                            </td>
                            <td class="setting-value">
                                <el-form-item :class="{'setting-items' : enableSwitch.disconnectAlertVolume.value, 'disable-setting-items' : !enableSwitch.disconnectAlertVolume.value}">
                                    <el-slider style="padding-left:10px;padding-right:10px;" v-model="inputForm.settingJson.Volume.disconnectAlertVolume" @change="handleChangeVolume('disconnectAlertVolume')" :disabled="!enableSwitch.disconnectAlertVolume.value || disabledChange"></el-slider>
                                </el-form-item>
                            </td>
                            <td class="setting-switch" style="padding-top:10px;">
                                <el-switch class="enableSwitch" v-model="enableSwitch.disconnectAlertVolume.value" active-color="#5171cb" @change="handleChangeVolume('disconnectAlertVolume')" :disabled="disabledChange"></el-switch>
                            </td>
                        </tr>
                        <tr>
                            <!--- 「聞く」グループの受信音　１行目 --->
                            <td class="setting-name-2" style="padding-top:20px">
                                <span v-t="'message.item_client_voice_level_during_duplicate'"/>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left"
                                        v-html="$t('message.hint_volume_duplicate_mode')"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')" alt="" />
                                </el-tooltip>
                            </td>
                            <td class="setting-value" style="padding-top:10px">
                                <el-form-item prop="duplicateVolume" ref="duplicateVolume" :class="{'setting-items' : enableSwitch.duplicateVolume.value, 'disable-setting-items' : !enableSwitch.duplicateVolume.value}">
                                    <el-select v-model="inputItems.duplicateVolume.value" v-on:change="handleChangeDuplicateVolume('duplicateVolume')" :disabled="!enableSwitch.duplicateVolume.value || disabledChange" :placeholder="$t('message.place_holder_select_item')">
                                        <el-option v-for="item in duplicateVolumeTypes" :key="item.value" :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </td>
                            <td class="setting-switch">
                                <el-switch class="enableSwitch" v-model="enableSwitch.duplicateVolume.value" active-color="#5171cb" @change="() => { handleChangeDuplicateVolume('duplicateVolume'); handleChangeToggleSwitch('Volume','duplicateMode',enableSwitch.duplicateVolume.value); }" :disabled="disabledChange"></el-switch>
                            </td>
                        </tr>
                        <tr>
                            <!--- 「聞く」グループの受信音　２行目 --->
                            <td class="setting-name-2">
                            </td>
                            <td class="setting-value">
                                <el-form-item class="setting-items">
                                    <el-radio-group v-model="inputForm.settingJson.Volume.duplicateMode" fill="#5171cb" @change="handleChangeToggleValue" :disabled="!enableSwitch.duplicateVolume.value || disabledChange">
                                        <el-radio :label="false"><span v-t="'message.item_client_voice_level_duplicate_overlapping'"/></el-radio>
                                        <el-radio :label="true"><span v-t="'message.item_client_voice_level_duplicate_always'"/></el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </td>
                            <td class="setting-switch">
                            </td>
                        </tr>
                        <tr>
                            <!--- ボリュームロックを無効にする --->
                            <td class="setting-name-2" v-t="'message.item_client_disable_volume_lock'">
                            </td>
                            <td class="setting-value">
                                <el-form-item :class="{'setting-items' : enableSwitch.lockedVolume.value, 'disable-setting-items' : !enableSwitch.lockedVolume.value}">
                                    <el-radio-group v-model="inputForm.settingJson.Volume.lockedVolume" fill="#5171cb" :disabled="!enableSwitch.lockedVolume.value || disabledChange">
                                        <el-radio :label="-1"><span v-t="'message.value_disable_mute'"/></el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </td>
                            <td class="setting-switch" style="padding-top:10px;">
                                <el-switch class="enableSwitch" v-model="enableSwitch.lockedVolume.value" active-color="#5171cb" @change="handleChangeLockedVolume(enableSwitch.lockedVolume.value)" :disabled="disabledChange"></el-switch>
                            </td>
                        </tr>
                        <tr>
                            <!--- マスターミュートを無効にする --->
                            <td class="setting-name-2" v-t="'message.item_client_disable_master_mute'">
                            </td>
                            <td class="setting-value">
                                <el-form-item :class="{'setting-items' : enableSwitch.masterSound.value, 'disable-setting-items' : !enableSwitch.masterSound.value}">
                                    <el-radio-group v-model="inputForm.settingJson.Volume.masterSound" fill="#5171cb" :disabled="!enableSwitch.masterSound.value || disabledChange">
                                        <el-radio :label="true"><span v-t="'message.value_disable_mute'"/></el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </td>
                            <td class="setting-switch" style="padding-top:10px;">
                                <el-switch class="enableSwitch" v-model="enableSwitch.masterSound.value" active-color="#5171cb" @change="handleChangeMasterSound(enableSwitch.masterSound.value)" :disabled="disabledChange"></el-switch>
                            </td>
                        </tr>
                        <!--- 通知設定 --->
                        <tr class="object-titlebox" style="display: table-row">
                            <td class="object-titlebox-text" style="width:250px;padding-left:20px;" v-t="'message.title_client_notification'"></td>
                            <td class="object-titlebox-text" style="padding-left:20px" v-t="'message.title_client_value'"></td>
                            <td class="setting-switch-header" v-t="'message.title_client_enabling'"></td>
                        </tr>
                        <tr>
                            <!---音声通知 --->
                            <td class="setting-name-2" style="padding-top:20px" v-t="'message.item_client_voice_notification'">
                            </td>
                            <td class="setting-value" style="padding-top:10px">
                                <el-form-item class="setting-items">
                                    <el-radio-group v-model="inputForm.settingJson.Notification.voiceNotification" fill="#5171cb" @change="handleChangeToggleValue" :disabled="!enableSwitch.voiceNotification.value || disabledChange">
                                        <el-radio :label="true"><span v-t="'message.value_on'"/></el-radio>
                                        <el-radio :label="false"><span v-t="'message.value_off'"/></el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </td>
                            <td class="setting-switch" style="padding-top:10px;">
                                <el-switch class="enableSwitch" v-model="enableSwitch.voiceNotification.value" active-color="#5171cb" @change="handleChangeToggleSwitch('Notification','voiceNotification',enableSwitch.voiceNotification.value)" :disabled="disabledChange"></el-switch>
                            </td>
                        </tr>
                        <tr>
                            <!---フォアグラウンド時に通知を表示する --->
                            <td class="setting-name-2" v-t="'message.item_client_notify_in_foreground'">
                            </td>
                            <td class="setting-value">
                                <el-form-item class="setting-items">
                                    <el-radio-group v-model="inputForm.settingJson.Notification.notifyInForeground" fill="#5171cb" @change="handleChangeToggleValue" :disabled="!enableSwitch.notifyInForeground.value || disabledChange">
                                        <el-radio :label="true"><span v-t="'message.value_on'"/></el-radio>
                                        <el-radio :label="false"><span v-t="'message.value_off'"/></el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </td>
                            <td class="setting-switch">
                                <el-switch class="enableSwitch" v-model="enableSwitch.notifyInForeground.value" active-color="#5171cb" @change="handleChangeToggleSwitch('Notification','notifyInForeground',enableSwitch.notifyInForeground.value)" :disabled="disabledChange"></el-switch>
                            </td>
                        </tr>
                        <tr>
                            <!---音声受信時の通知 --->
                            <td class="setting-name-2" v-t="'message.item_client_talk_notification'">
                            </td>
                            <td class="setting-value">
                                <el-form-item class="setting-items">
                                    <el-radio-group v-model="inputForm.settingJson.Notification.onNewTalker" fill="#5171cb" @change="handleChangeToggleValue" :disabled="!enableSwitch.onNewTalker.value || disabledChange">
                                        <el-radio :label="true"><span v-t="'message.value_on'"/></el-radio>
                                        <el-radio :label="false"><span v-t="'message.value_off'"/></el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </td>
                            <td class="setting-switch">
                                <el-switch class="enableSwitch" v-model="enableSwitch.onNewTalker.value" active-color="#5171cb" @change="handleChangeToggleSwitch('Notification','onNewTalker',enableSwitch.onNewTalker.value)" :disabled="disabledChange"></el-switch>
                            </td>
                        </tr>
                        <tr>
                            <!---音声受信時の振動 --->
                            <td class="setting-name-2" v-t="'message.item_client_talk_vibe'">
                            </td>
                            <td class="setting-value">
                                <el-form-item class="setting-items">
                                    <el-radio-group v-model="inputForm.settingJson.Notification.vibeOnNewTalker" fill="#5171cb" @change="handleChangeToggleValue" :disabled="!enableSwitch.vibeOnNewTalker.value || disabledChange">
                                        <el-radio :label="true"><span v-t="'message.value_on'"/></el-radio>
                                        <el-radio :label="false"><span v-t="'message.value_off'"/></el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </td>
                            <td class="setting-switch">
                                <el-switch class="enableSwitch" v-model="enableSwitch.vibeOnNewTalker.value" active-color="#5171cb" @change="handleChangeToggleSwitch('Notification','vibeOnNewTalker',enableSwitch.vibeOnNewTalker.value)" :disabled="disabledChange"></el-switch>
                            </td>
                        </tr>
                        <tr>
                            <!---音声受信時の振動パターン --->
                            <td class="setting-name-2" v-t="'message.item_client_talk_vibe_pattern'">
                            </td>
                            <td class="setting-value">
                                <el-form-item class="setting-items" prop="vibeTypeOnNewTalker" ref="vibeTypeOnNewTalker">
                                    <el-select v-model="inputItems.vibeTypeOnNewTalker.value" ref="vibeTypeOnNewTalker" v-on:change="handleChangeItems('vibeTypeOnNewTalker')" :disabled="!inputItems.vibeTypeOnNewTalker.enable || disabledChange"  :placeholder="$t('message.place_holder_select_item')">
                                        <el-option v-for="item in vibeTypes" :key="item.value" :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </td>
                            <td class="setting-switch">
                                <el-switch class="enableSwitch" v-model="inputItems.vibeTypeOnNewTalker.enable" active-color="#5171cb" @change="handleChangeItems('vibeTypeOnNewTalker')" :disabled="disabledChange"></el-switch>
                            </td>
                        </tr>
                        <tr>
                            <!---メッセージ受信時の通知 --->
                            <td class="setting-name-2" v-t="'message.item_client_msg_notification'">
                            </td>
                            <td class="setting-value">
                                <el-form-item class="setting-items">
                                    <el-radio-group v-model="inputForm.settingJson.Notification.onNewMessage" fill="#5171cb" @change="handleChangeToggleValue" :disabled="!enableSwitch.onNewMessage.value || disabledChange">
                                        <el-radio :label="true"><span v-t="'message.value_on'"/></el-radio>
                                        <el-radio :label="false"><span v-t="'message.value_off'"/></el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </td>
                            <td class="setting-switch">
                                <el-switch class="enableSwitch" v-model="enableSwitch.onNewMessage.value" active-color="#5171cb" @change="handleChangeToggleSwitch('Notification','onNewMessage',enableSwitch.onNewMessage.value)" :disabled="disabledChange"></el-switch>
                            </td>
                        </tr>
                        <tr>
                            <!---メッセージ受信時の振動 --->
                            <td class="setting-name-2" v-t="'message.item_client_msg_vibe'">
                            </td>
                            <td class="setting-value">
                                <el-form-item class="setting-items">
                                    <el-radio-group v-model="inputForm.settingJson.Notification.vibeOnNewMessage" fill="#5171cb" @change="handleChangeToggleValue" :disabled="!enableSwitch.vibeOnNewMessage.value || disabledChange">
                                        <el-radio :label="true"><span v-t="'message.value_on'"/></el-radio>
                                        <el-radio :label="false"><span v-t="'message.value_off'"/></el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </td>
                            <td class="setting-switch">
                                <el-switch class="enableSwitch" v-model="enableSwitch.vibeOnNewMessage.value" active-color="#5171cb" @change="handleChangeToggleSwitch('Notification','vibeOnNewMessage',enableSwitch.vibeOnNewMessage.value)" :disabled="disabledChange"></el-switch>
                            </td>
                        </tr>
                        <tr>
                            <!---メッセージ受信時の振動パターン --->
                            <td class="setting-name-2" v-t="'message.item_client_msg_vibe_pattern'">
                            </td>
                            <td class="setting-value">
                                <el-form-item class="setting-items" prop="vibeTypeOnNewMessage" ref="vibeTypeOnNewMessage">
                                    <el-select v-model="inputItems.vibeTypeOnNewMessage.value" ref="vibeTypeOnNewMessage" v-on:change="handleChangeItems('vibeTypeOnNewMessage')" :disabled="!inputItems.vibeTypeOnNewMessage.enable || disabledChange"  :placeholder="$t('message.place_holder_select_item')">
                                        <el-option v-for="item in vibeTypes" :key="item.value" :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </td>
                            <td class="setting-switch">
                                <el-switch class="enableSwitch" v-model="inputItems.vibeTypeOnNewMessage.enable" active-color="#5171cb" @change="handleChangeItems('vibeTypeOnNewMessage')" :disabled="disabledChange"></el-switch>
                            </td>
                        </tr>
                        <!--- Bluetoothアラート設定 --->
                        <tr class="object-titlebox" style="display: table-row">
                            <td class="object-titlebox-text" style="width:250px;padding-left:20px;" v-t="'message.title_client_bluetooth_alert'"></td>
                            <td class="object-titlebox-text" style="padding-left:20px" v-t="'message.title_client_value'"></td>
                            <td class="setting-switch-header" v-t="'message.title_client_enabling'"></td>
                        </tr>
                        <tr>
                            <!---Bluetoorh切断時のアラート --->
                            <td class="setting-name-2" style="padding-top:20px" v-t="'message.item_client_bluetooth_alert'">
                            </td>
                            <td class="setting-value" style="padding-top:10px">
                                <el-form-item class="setting-items">
                                    <el-radio-group v-model="inputForm.settingJson.Common.bluetoothAlert" fill="#5171cb" @change="handleChangeToggleValue" :disabled="!enableSwitch.bluetoothAlert.value || disabledChange">
                                        <el-radio :label="true"><span v-t="'message.value_on'"></span></el-radio>
                                        <el-radio :label="false"><span v-t="'message.value_off'"></span></el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </td>
                            <td class="setting-switch" style="padding-top:10px">
                                <el-switch class="enableSwitch" v-model="enableSwitch.bluetoothAlert.value" active-color="#5171cb" @change="handleChangeToggleSwitch('Common','bluetoothAlert',enableSwitch.bluetoothAlert.value)" :disabled="disabledChange"></el-switch>
                            </td>
                        </tr>
                        <tr>
                            <!--- アラートの終了時間--->
                            <td class="setting-name-2" v-t="'message.item_client_bluetooth_alert_period_time'">
                            </td>
                            <td class="setting-value">
                                <el-form-item prop="alertPeriod" ref="alertPeriod">
                                    <el-input id="alertPeriod" :placeholder="$t('message.place_holder_input_text')" v-model="inputItems.alertPeriod.value" :disabled="!inputItems.alertPeriod.enable || disabledChange"
                                         maxlength="4" max="1000" min="10" style="width:170px"
                                         @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                         clearable @clear="inputCheckAll()"/>
                                    <span v-t="'message.unit_sec'"></span>
                                </el-form-item>
                            </td>
                            <td class="setting-switch">
                                <el-switch class="enableSwitch" v-model="inputItems.alertPeriod.enable" active-color="#5171cb" @change="handleChangeItems('alertPeriod')" :disabled="disabledChange"></el-switch>
                            </td>
                        </tr>
                        <tr>
                            <!--- アラートのタイプ設定--->
                            <td class="setting-name-2" style="padding-top:30px" v-t="'message.item_client_bluetooth_alert_type'">
                            </td>
                            <td class="setting-value">
                                <el-form-item class="setting-items">
                                    <span style="display: inline-block; width: 120px" v-t="'message.item_fixed_phrase_sound'" :disabled="!enableSwitch.alertOption.value || disabledChange"></span>：
                                    <el-radio
                                        :label="true"
                                        v-model="bitStatus.alertOption.alertOptionSound"
                                        @change="handleChangeToggleValue_Bit('Common','alertOption','alertOptionSound',CONSTANT.BLUETOOTH_ALERT_SOUND)"
                                        :disabled="!enableSwitch.alertOption.value || disabledChange"
                                    >
                                        <span v-t="'message.value_on'"></span>
                                    </el-radio>
                                    <el-radio
                                        :label="false"
                                        v-model="bitStatus.alertOption.alertOptionSound"
                                        @change="handleChangeToggleValue_Bit('Common','alertOption','alertOptionSound',CONSTANT.BLUETOOTH_ALERT_SOUND)"
                                        :disabled="!enableSwitch.alertOption.value || disabledChange"
                                    >
                                        <span v-t="'message.value_off'"></span>
                                    </el-radio>
                                </el-form-item>

                                <el-form-item class="setting-items">
                                    <span style="display: inline-block; width: 120px" v-t="'message.item_fixed_phrase_vibration'" :disabled="!enableSwitch.alertOption.value || disabledChange"></span>：
                                    <el-radio
                                        :label="true"
                                        v-model="bitStatus.alertOption.alertOptionVib"
                                        @change="handleChangeToggleValue_Bit('Common','alertOption','alertOptionVib',CONSTANT.BLUETOOTH_ALERT_VIB)"
                                        :disabled="!enableSwitch.alertOption.value || disabledChange"
                                    >
                                        <span v-t="'message.value_on'"></span>
                                    </el-radio>
                                    <el-radio
                                        :label="false"
                                        v-model="bitStatus.alertOption.alertOptionVib"
                                        @change="handleChangeToggleValue_Bit('Common','alertOption','alertOptionVib',CONSTANT.BLUETOOTH_ALERT_VIB)"
                                        :disabled="!enableSwitch.alertOption.value || disabledChange"
                                    >
                                        <span v-t="'message.value_off'"></span>
                                    </el-radio>
                                </el-form-item>
                            </td>
                            <td class="setting-switch">
                                <el-switch class="enableSwitch" v-model="enableSwitch.alertOption.value" active-color="#5171cb" @change="handleChangeToggleSwitch_Bit('Common','alertOption',enableSwitch.alertOption.value)" :disabled="disabledChange"></el-switch>
                            </td>
                        </tr>

                        <!--- ボタン割り当て設定 --->
                        <tr class="object-titlebox" style="display: table-row">
                            <td class="object-titlebox-text" style="width:250px;padding-left:20px;" v-t="'message.title_client_deviceButton'"></td>
                            <td class="object-titlebox-text" style="padding-left:20px" v-t="'message.title_client_value'"></td>
                            <td class="setting-switch-header" v-t="'message.title_client_enabling'"></td>
                        </tr>
                        <tr>

                            <td v-if="$i18n.locale === 'ja'" colspan="3" style="padding-left: 20px; padding-top: 10px; padding-bottom: 10px">
                                <span v-t="'message.hint_client_deviceButton1'"></span>
                                <router-link to="/manual">
                                    <span v-t="'message.menu_manual'"></span>
                                </router-link>
                                <span v-t="'message.hint_client_deviceButton2'"></span>
                            </td>
                        </tr>

                        <!-- ボタン1-5 -->
                        <tr v-for="(serverButtonBind, deviceButtonItemIndex) in deviceButtonItemList" class="setting-item-record">
                            <td class="setting-name-2" v-t="{ path: 'message.item_client_deviceButton', args: { number: deviceButtonItemIndex + 1 } }"></td>
                            <td class="setting-value" style="padding-top:10px">
                                <el-form-item class="setting-items" :prop="serverButtonBind" :ref="serverButtonBind">
                                    <el-select
                                        v-model="inputItems.serverButtonBind.value[deviceButtonItemIndex]"
                                        @change="handleChangeArrayItems('serverButtonBind', deviceButtonItemIndex)"
                                        :disabled="!inputItems.serverButtonBind.enable[deviceButtonItemIndex]"
                                        :placeholder="$t('message.place_holder_select_item')">
                                        <el-option v-for="item in deviceButtonTypes" :key="item.value" :label="item.label" :value="item.value" :disabled="disabledChange"></el-option>
                                    </el-select>
                                </el-form-item>
                            </td>
                            <td class="setting-switch">
                                <el-switch
                                    class="enableSwitch"
                                    style="padding-top:10px"
                                    v-model="inputItems.serverButtonBind.enable[deviceButtonItemIndex]"
                                    active-color="#5171cb"
                                    @change="handleChangeArrayItems('serverButtonBind', deviceButtonItemIndex)"
                                    :disabled="disabledChange">
                                </el-switch>
                            </td>
                        </tr>
                    </table>
                </el-form>
            </div>
            <hr class="dialog-hr">
            <div class="dialog-button-field">
                <el-button class="dialog-cancel-button" type="button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                <el-button class="dialog-ok-button" :disabled="disableSave || disabledChange" @click="modifyClientSetting" v-t="'message.button_save'"></el-button>
            </div>
        </div>
    </div>
</transition>
</template>

<script>
import commonUtil from '../../../commonutil.js';
import commonValidate from '../../../common-validate.js';
import constants from '../../../constants.js';
import EditClientSettingFixedPhrase from "@/components/pc/setting/clientsetting/ClientSettingFixedPhraseEdit.vue"
import {FEATURE_CUT_VOICE_DELAY} from "@/components/feature_toggles/feature_toggle";

export default {
    components: {
        EditClientSettingFixedPhrase: EditClientSettingFixedPhrase
    },

    props: {
        orgSettingName: String,
        clientSettingInfo: {},
        fixedPhraseItem: {},
        fixedPhraseItemList: Array(),
        deviceButtonItemList: Array(),
        tenantApps: Number,
        disabledChange: false,
        clientSettingsForEachNode: false,
        tenantOption: Number,
        enableSafetySupport: Boolean,
    },

    computed: {
        enableVoiceDelay() {
            return FEATURE_CUT_VOICE_DELAY;
        },
    },

    data() {
        return {
            CONSTANT: {
                BLUETOOTH_ALERT_SOUND: constants.BLUETOOTH_ALERT_SOUND,
                BLUETOOTH_ALERT_VIB: constants.BLUETOOTH_ALERT_VIB,
            },
            inputItems: {
                settingName:            { category: "",              enable: true,    validationRule: "clientSettingName", valid: true, value: "", isComposing: false },
                subButtonMode:          { category: "Common",        enable: true,    validationRule: "selectItem",     valid: true, value: "" },
                subButtonLeftMode:      { category: "Common",        enable: true,    validationRule: "selectItem",     valid: true, value: "" },
                customURL:              { category: "Common",        enable: true,    validationRule: "urlScheme",      valid: true, value: "", isComposing: false },
                customURLAndroid:       { category: "Common",        enable: true,    validationRule: "urlScheme",      valid: true, valid1:false, valid2:false, value1: "", value2: "", isComposing: false },
                locationInterval:       { category: "Common",        enable: true,    validationRule: "selectItem",     valid: true, value: "" },
                cutVoiceDelayQueueSeconds: { category: "Talk",          enable: true,    validationRule: "selectItem",     valid: true, value: "" },
                fixedPhraseTitle1:      { category: "Common",        enable: true,    validationRule: "reqDisplayName", valid: true, value: "" },
                fixedPhrase1:           { category: "Common",        enable: true,    validationRule: null,             valid: true, value: "" },
                fixedPhraseTitle2:      { category: "Common",        enable: true,    validationRule: "reqDisplayName", valid: true, value: "" },
                fixedPhrase2:           { category: "Common",        enable: true,    validationRule: null,             valid: true, value: "" },
                fixedPhraseTitle3:      { category: "Common",        enable: true,    validationRule: "reqDisplayName", valid: true, value: "" },
                fixedPhrase3:           { category: "Common",        enable: true,    validationRule: null,             valid: true, value: "" },
                fixedPhraseTitle4:      { category: "Common",        enable: true,    validationRule: "reqDisplayName", valid: true, value: "" },
                fixedPhrase4:           { category: "Common",        enable: true,    validationRule: null,             valid: true, value: "" },
                fixedPhraseTitle5:      { category: "Common",        enable: true,    validationRule: "reqDisplayName", valid: true, value: "" },
                fixedPhrase5:           { category: "Common",        enable: true,    validationRule: null,             valid: true, value: "" },
                fixedPhraseTitle6:      { category: "Common",        enable: true,    validationRule: "reqDisplayName", valid: true, value: "" },
                fixedPhrase6:           { category: "Common",        enable: true,    validationRule: null,             valid: true, value: "" },
                fixedPhraseTitle7:      { category: "Common",        enable: true,    validationRule: "reqDisplayName", valid: true, value: "" },
                fixedPhrase7:           { category: "Common",        enable: true,    validationRule: null,             valid: true, value: "" },
                fixedPhraseTitle8:      { category: "Common",        enable: true,    validationRule: "reqDisplayName", valid: true, value: "" },
                fixedPhrase8:           { category: "Common",        enable: true,    validationRule: null,             valid: true, value: "" },
                fixedPhraseTitle9:      { category: "Common",        enable: true,    validationRule: "reqDisplayName", valid: true, value: "" },
                fixedPhrase9:           { category: "Common",        enable: true,    validationRule: null,             valid: true, value: "" },
                fixedPhraseTitle10:     { category: "Common",        enable: true,    validationRule: "reqDisplayName", valid: true, value: "" },
                fixedPhrase10:          { category: "Common",        enable: true,    validationRule: null,             valid: true, value: "" },
                fixedPhraseTitle11:     { category: "Common",        enable: true,    validationRule: "reqDisplayName", valid: true, value: "" },
                fixedPhrase11:          { category: "Common",        enable: true,    validationRule: null,             valid: true, value: "" },
                fixedPhraseTitle12:     { category: "Common",        enable: true,    validationRule: "reqDisplayName", valid: true, value: "" },
                fixedPhrase12:          { category: "Common",        enable: true,    validationRule: null,             valid: true, value: "" },
                fixedPhraseTitle13:     { category: "Common",        enable: true,    validationRule: "reqDisplayName", valid: true, value: "" },
                fixedPhrase13:          { category: "Common",        enable: true,    validationRule: null,             valid: true, value: "" },
                fixedPhraseTitle14:     { category: "Common",        enable: true,    validationRule: "reqDisplayName", valid: true, value: "" },
                fixedPhrase14:          { category: "Common",        enable: true,    validationRule: null,             valid: true, value: "" },
                fixedPhraseTitle15:     { category: "Common",        enable: true,    validationRule: "reqDisplayName", valid: true, value: "" },
                fixedPhrase15:          { category: "Common",        enable: true,    validationRule: null,             valid: true, value: "" },
                fixedPhraseTitle16:     { category: "Common",        enable: true,    validationRule: "reqDisplayName", valid: true, value: "" },
                fixedPhrase16:          { category: "Common",        enable: true,    validationRule: null,             valid: true, value: "" },
                fixedPhraseTitle17:     { category: "Common",        enable: true,    validationRule: "reqDisplayName", valid: true, value: "" },
                fixedPhrase17:          { category: "Common",        enable: true,    validationRule: null,             valid: true, value: "" },
                fixedPhraseTitle18:     { category: "Common",        enable: true,    validationRule: "reqDisplayName", valid: true, value: "" },
                fixedPhrase18:          { category: "Common",        enable: true,    validationRule: null,             valid: true, value: "" },
                fixedPhraseTitle19:     { category: "Common",        enable: true,    validationRule: "reqDisplayName", valid: true, value: "" },
                fixedPhrase19:          { category: "Common",        enable: true,    validationRule: null,             valid: true, value: "" },
                fixedPhraseTitle20:     { category: "Common",        enable: true,    validationRule: "reqDisplayName", valid: true, value: "" },
                fixedPhrase20:          { category: "Common",        enable: true,    validationRule: null,             valid: true, value: "" },
                voiceReportNotifyMessage:     { category: "Common",        enable: true,    validationRule: "reqText",        valid: true, value: "", maxLength: 120 },
                preferredNetworkAndroid:{ category: "Common",        enable: true,    validationRule: "selectItem",     valid: true, value: "" },
                preferredNetworkIOS:    { category: "Common",        enable: true,    validationRule: "selectItem",     valid: true, value: "" },
                alertPeriod:            { category: "Common",        enable: true,    validationRule: "numeric",        valid: true, value: "" , min: 10, max: 1000 },
                serverButtonBind:       { category: "Common",        enable:[false,false,false,false,false,false,false,false,false,false],    validationRule: "selectItem",     valid:[true, true, true, true, true,true, true, true, true, true], value: ["","","","","","","","","",""] },
                resolution:             { category: "Video",         enable: true,    validationRule: "selectItem",     valid: true, value: "" },
                duplicateVolume:        { category: "Volume",        enable: true,    validationRule: "selectItem",     valid: true, value: "" },
                vibeTypeOnNewTalker:    { category: "Notification",  enable: true,    validationRule: "selectItem",     valid: true, value: "" },
                vibeTypeOnNewMessage:   { category: "Notification",  enable: true,    validationRule: "selectItem",     valid: true, value: "" },
            },
            disableSave: true,
            inputForm: {
                settingName: null,
                settingJson: {
                    Common: {
                        autoStart: 0,
                        subButtonMode: null,
                        subButtonLeftMode: null,
                        customURL: null,
                        linkPackageName: null,
                        linkClassName: null,
                        locationAcquire: null,
                        locationUpload: 0,
                        locationInterval: null,
                        iOSAudioMode: null,
                        stayAwake: null,
                        mapMode: null,
                        mapType: null,
                        fixedPhraseTitle1: null,
                        fixedPhrase1: null,
                        fixedPhraseTitle2: null,
                        fixedPhrase2: null,
                        fixedPhraseTitle3: null,
                        fixedPhrase3: null,
                        fixedPhraseTitle4: null,
                        fixedPhrase4: null,
                        fixedPhraseTitle5: null,
                        fixedPhrase5: null,
                        fixedPhraseTitle6: null,
                        fixedPhrase6: null,
                        fixedPhraseTitle7: null,
                        fixedPhrase7: null,
                        fixedPhraseTitle8: null,
                        fixedPhrase8: null,
                        fixedPhraseTitle9: null,
                        fixedPhrase9: null,
                        fixedPhraseTitle10: null,
                        fixedPhrase10: null,
                        fixedPhraseTitle11: null,
                        fixedPhrase11: null,
                        fixedPhraseTitle12: null,
                        fixedPhrase12: null,
                        fixedPhraseTitle13: null,
                        fixedPhrase13: null,
                        fixedPhraseTitle14: null,
                        fixedPhrase14: null,
                        fixedPhraseTitle15: null,
                        fixedPhrase15: null,
                        fixedPhraseTitle16: null,
                        fixedPhrase16: null,
                        fixedPhraseTitle17: null,
                        fixedPhrase17: null,
                        fixedPhraseTitle18: null,
                        fixedPhrase18: null,
                        fixedPhraseTitle19: null,
                        fixedPhrase19: null,
                        fixedPhraseTitle20: null,
                        fixedPhrase20: null,
                        voiceReportEnableNotify: 0,
                        voiceReportShowPopup: 0,
                        voiceReportNotifyMessage: null,
                        voiceReportSubscribeByDefault: 0,
                        preferredNetworkAndroid: null,
                        preferredNetworkIOS: null,
                        bluetoothAlert : null,
                        alertPeriod: null,
                        alertOption : null,
                        serverButtonBind : [-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],
                    },
                    Talk:{
                        buttonMode: null,
                        bleButtonMode: null,
                        miniTalkButtonMode: null,
                        faceToTalkMode: null,
                        vox: null,
                        echo: null,
                        backgroundMic: null,
                        voiceProcessing: null,
                        cutVoiceDelayQueueSeconds: null,
                    },
                    Chat:{
                        chatSubscribeMode: null,
                        autoSpeak: null,
                        autoSpeakText: null,
                        cameraPreview: null
                    },
                    Video:{
                        resolution: null
                    },
                    Volume: {
                        reconnectSound: 1,
                        reconnectSoundVolume: 100,
                        alertSound: 1,
                        alertSoundVolume: 100,
                        reactionSound: 1,
                        reactionSoundVolume: 100,
                        receiveBeep: 1,
                        receiveBeepVolume: 100,
                        voice: 1,
                        voiceVolume: 200,
                        voiceOffHook: 1,
                        voiceOffHookVolume: 200,
                        effectSound: 1,
                        effectSoundVolume: 100,
                        echoSoundVolume: 100,
                        inSpeechAlertSound: 1,
                        inSpeechAlertVolume: 100,
                        disconnectAlertVolume: 100,
                        duplicateVolume: 100,
                        duplicateMode: 0,
                        micVolume: 200,
                        lockedVolume: null,
                        masterSound: 1,
                    },
                    Notification:{
                        notifyInForeground: 0,
                        onNewTalker: 0,
                        vibeOnNewTalker: 0,
                        vibeTypeOnNewTalker: null,
                        onNewMessage: 0,
                        vibeOnNewMessage: 0,
                        vibeTypeOnNewMessage: null,
                        voiceNotification: 0,
                    },
                },
            },
            locationIntervalTypes: [],
            cutVoiceDelayQueueSecondsTypes: [],
            vibeTypes: [],
            subButtonTypes: [],
            deviceButtonTypes: [],
            preferredNetworkAndroidTypes: [],
            preferredNetworkIOSTypes: [],
            resolutionTypes: [],
            duplicateVolumeTypes: [],
            enableSwitch: {
                autoStart:              { value: true, category: "Common" },
                locationAcquire:        { value: true, category: "Common" },
                locationUpload:         { value: true, category: "Common" },
                iOSAudioMode:           { value: true, category: "Common" },
                stayAwake:              { value: true, category: "Common" },
                mapMode:                { value: true, category: "Common" },
                mapType:                { value: true, category: "Common" },
                bluetoothAlert:         { value: true, category: "Common" },
                alertOption:            { value: true, category: "Common" },
                voiceReportEnableNotify:  { value: true, category: "Common" },
                voiceReportShowPopup:         { value: true, category: "Common" },
                voiceReportSubscribeByDefault:   { value: true, category: "Common" },
                buttonMode:             { value: true, category: "Talk" },
                bleButtonMode:          { value: true, category: "Talk" },
                miniTalkButtonMode:     { value: true, category: "Talk" },
                faceToTalkMode:         { value: true, category: "Talk" },
                vox:                    { value: true, category: "Talk" },
                echo:                   { value: true, category: "Talk" },
                backgroundMic:          { value: true, category: "Talk" },
                voiceProcessing:        { value: true, category: "Talk" },
                chatSubscribeMode:      { value: true, category: "Chat" },
                autoSpeak:              { value: true, category: "Chat" },
                autoSpeakText:          { value: true, category: "Chat" },
                cameraPreview:          { value: true, category: "Chat" },
                reconnectSoundVolume:   { value: true, category: "Volume" },
                alertSoundVolume:       { value: true, category: "Volume" },
                reactionSoundVolume:    { value: true, category: "Volume" },
                receiveBeepVolume:      { value: true, category: "Volume" },
                voiceVolume:            { value: true, category: "Volume" },
                voiceOffHookVolume:     { value: true, category: "Volume" },
                micVolume:              { value: true, category: "Volume" },
                effectSoundVolume:      { value: true, category: "Volume" },
                echoSoundVolume:        { value: true, category: "Volume" },
                inSpeechAlertVolume:    { value: true, category: "Volume" },
                disconnectAlertVolume:  { value: true, category: "Volume" },
                duplicateVolume:        { value: true, category: "Volume" },
                lockedVolume:           { value: true, category: "Volume" },
                masterSound:            { value: true, category: "Volume" },
                notifyInForeground:     { value: true, category: "Notification" },
                onNewTalker:            { value: true, category: "Notification" },
                vibeOnNewTalker:        { value: true, category: "Notification" },
                vibeOnNewMessage:       { value: true, category: "Notification" },
                onNewMessage:           { value: true, category: "Notification" },
                voiceNotification:      { value: true, category: "Notification" }
            },
            bitStatus: {
                alertOption: {
                    alertOptionSound: null,
                    alertOptionVib: null,
                },
            },
        };
    },

    created: function() {
        this.vibeTypes  = commonUtil.getVibrationList(this.$i18n);
        this.subButtonTypes = commonUtil.getSubButtonModeList(this.$i18n,this.enableSafetySupport,this.tenantApps);
        this.deviceButtonTypes = commonUtil.getServerButtonBindActionList(this.$i18n,this.tenantApps,this.enableSafetySupport);
        this.preferredNetworkAndroidTypes = commonUtil.getPreferredNetworkAndroidList(this.$i18n);
        this.preferredNetworkIOSTypes = commonUtil.getPreferredNetworkIOSList(this.$i18n);
        this.locationIntervalTypes = commonUtil.getLocationIntervalModeList(this.$i18n);
        this.cutVoiceDelayQueueSecondsTypes = commonUtil.getCutVoiceDelayQueueSecondsList(this.$i18n);
        this.resolutionTypes = commonUtil.getResolutionList(this.$i18n);
        this.duplicateVolumeTypes = commonUtil.getDuplicateVolumeList(this.$i18n);
        // set enable switch setting.
        for (let item in this.enableSwitch) {
            let categorySetting = this.clientSettingInfo[this.enableSwitch[item].category];
            this.enableSwitch[item].value = categorySetting[item] == undefined ? false : true;
        }
        for (let item in this.inputItems) {
            if (item == "settingName" || item == "serverButtonBind") {
                continue;
            }
            let categorySetting = this.clientSettingInfo[this.inputItems[item].category];
            this.inputItems[item].enable = categorySetting[item] == undefined ? false : true;
        }
        // set input form (current value or default value)
        this.inputItems.settingName.value = this.orgSettingName;
        for (let item in this.inputForm.settingJson.Common) {
            let currentSetting = this.clientSettingInfo.Common[item];
            switch(item) {
                case "autoStart":
                case "locationAcquire":
                case "locationUpload":
                case "iOSAudioMode":
                case "stayAwake":
                case "mapMode":
                case "mapType":
                case "bluetoothAlert":
                case "voiceReportEnableNotify":
                case "voiceReportShowPopup":
                case "voiceReportSubscribeByDefault":
                    if (this.enableSwitch[item].value) {
                        this.inputForm.settingJson.Common[item] = currentSetting == 1;
                    } else {
                        this.inputForm.settingJson.Common[item] = null;
                    }
                    break;
                case "linkPackageName":
                case "linkClassName":
                    this.inputForm.settingJson.Common[item] = currentSetting == null ? this.inputForm.settingJson.Common[item] : currentSetting
                    this.inputItems.customURLAndroid.enable = currentSetting != null;
                    break;
                case "alertOption":
                    if (this.enableSwitch[item].value) {
                        this.inputForm.settingJson.Common[item] = currentSetting;
                        this.bitStatus["alertOption"]["alertOptionSound"] = (currentSetting & constants.BLUETOOTH_ALERT_SOUND) === constants.BLUETOOTH_ALERT_SOUND
                        this.bitStatus["alertOption"]["alertOptionVib"]   = (currentSetting & constants.BLUETOOTH_ALERT_VIB)   === constants.BLUETOOTH_ALERT_VIB
                    } else {
                        this.inputForm.settingJson.Common[item] = null;
                    }
                    break;
                case "serverButtonBind":
                    if (currentSetting != undefined) {
                        this.inputItems[item].value.forEach((_, index) => {
                            this.inputItems[item].value = currentSetting;
                            this.inputItems[item].value[index] = this.inputItems[item].value[index] === -1 ? "" : this.inputItems[item].value[index];
                            this.inputItems[item].value[index] = this.inputItems[item].value[index] === 5 && (this.tenantApps & constants.CHAT_GPT) === 0 ? "" : this.inputItems[item].value[index];
                            this.inputItems[item].enable[index] = this.inputItems[item].value[index] === "" ? false : true;
                        });
                    }
                    break;
                default:
                    this.inputForm.settingJson.Common[item] = currentSetting == null ? this.inputForm.settingJson.Common[item] : currentSetting
                    break;
            }
        }
        for (let item in this.inputForm.settingJson.Talk) {
            let currentSetting = this.clientSettingInfo.Talk[item];
            switch(item) {
                case "buttonMode":
                case "bleButtonMode":
                case "miniTalkButtonMode":
                case "cameraPreview":
                case "faceToTalkMode":
                case "vox":
                case "echo":
                case "backgroundMic":
                case "voiceProcessing":
                    if (this.enableSwitch[item].value) {
                        this.inputForm.settingJson.Talk[item] = currentSetting == 1;
                    } else {
                        this.inputForm.settingJson.Talk[item] = null;
                    }
                    break;
                default:
                    this.inputForm.settingJson.Talk[item] = currentSetting == null ? this.inputForm.settingJson.Talk[item] : currentSetting
                    break;
            }
        }
        for (let item in this.inputForm.settingJson.Chat) {
            if (this.enableSwitch[item].value) {
                this.inputForm.settingJson.Chat[item] = this.clientSettingInfo.Chat[item] == 1;
            } else {
                this.inputForm.settingJson.Chat[item] = null;
            }
        }
        for (let item in this.inputForm.settingJson.Video) {
            let currentSetting = this.clientSettingInfo.Video[item];
            this.inputForm.settingJson.Video[item] = currentSetting == null ? this.inputForm.settingJson.Video[item] : currentSetting
        }
        for (let item in this.inputForm.settingJson.Volume) {
            let currentSetting = this.clientSettingInfo.Volume[item];
            switch(item) {
                case "reconnectSoundVolume":
                case "alertSoundVolume":
                case "reactionSoundVolume":
                case "receiveBeepVolume":
                case "voiceVolume":
                case "voiceOffHookVolume":
                case "effectSoundVolume":
                case "echoSoundVolume":
                case "inSpeechAlertVolume":
                case "disconnectAlertVolume":
                case "duplicateVolume":
                case "micVolume":
                case "lockedVolume":
                    this.inputForm.settingJson.Volume[item] = currentSetting;
                    break;
                case "duplicateMode":
                    if (this.enableSwitch["duplicateVolume"].value) {
                        this.inputForm.settingJson.Volume[item] = (currentSetting === 1);
                    } else {
                        this.inputForm.settingJson.Volume[item] = null;
                    }
                    break;
                case "masterSound":
                    this.inputForm.settingJson.Volume[item] = (currentSetting === 1);
                    break;
                default:
                    break;
            }
        }
        for (let item in this.inputForm.settingJson.Notification) {
            let currentSetting = this.clientSettingInfo.Notification[item];
            switch(item) {
                case "notifyInForeground":
                case "onNewTalker":
                case "vibeOnNewTalker":
                case "onNewMessage":
                case "vibeOnNewMessage":
                case "voiceNotification":
                    if (this.enableSwitch[item].value) {
                        this.inputForm.settingJson.Notification[item] = currentSetting == 1;
                    } else {
                        this.inputForm.settingJson.Notification[item] = null;
                    }
                    break;
                default:
                    this.inputForm.settingJson.Notification[item] = currentSetting == null ? this.inputForm.settingJson.Notification[item] : currentSetting;
                    break;
            }
        }
        this.inputItems.customURL.value = this.inputForm.settingJson.Common.customURL;
        this.inputItems.subButtonMode.value = this.inputForm.settingJson.Common.subButtonMode;
        this.inputItems.subButtonLeftMode.value = this.inputForm.settingJson.Common.subButtonLeftMode;
        this.inputItems.locationInterval.value = this.inputForm.settingJson.Common.locationInterval;
        this.inputItems.cutVoiceDelayQueueSeconds.value = this.inputForm.settingJson.Talk.cutVoiceDelayQueueSeconds;
        this.inputItems.vibeTypeOnNewTalker.value = this.inputForm.settingJson.Notification.vibeTypeOnNewTalker;
        this.inputItems.vibeTypeOnNewMessage.value = this.inputForm.settingJson.Notification.vibeTypeOnNewMessage;
        this.inputItems.customURLAndroid.value1 = this.inputForm.settingJson.Common.linkPackageName;
        this.inputItems.customURLAndroid.value2 = this.inputForm.settingJson.Common.linkClassName;
        this.inputItems.fixedPhraseTitle1.value = this.inputForm.settingJson.Common.fixedPhraseTitle1;
        this.inputItems.fixedPhrase1.value = this.inputForm.settingJson.Common.fixedPhrase1;
        this.inputItems.fixedPhraseTitle2.value = this.inputForm.settingJson.Common.fixedPhraseTitle2;
        this.inputItems.fixedPhrase2.value = this.inputForm.settingJson.Common.fixedPhrase2;
        this.inputItems.fixedPhraseTitle3.value = this.inputForm.settingJson.Common.fixedPhraseTitle3;
        this.inputItems.fixedPhrase3.value = this.inputForm.settingJson.Common.fixedPhrase3;
        this.inputItems.fixedPhraseTitle4.value = this.inputForm.settingJson.Common.fixedPhraseTitle4;
        this.inputItems.fixedPhrase4.value = this.inputForm.settingJson.Common.fixedPhrase4;
        this.inputItems.fixedPhraseTitle5.value = this.inputForm.settingJson.Common.fixedPhraseTitle5;
        this.inputItems.fixedPhrase5.value = this.inputForm.settingJson.Common.fixedPhrase5;
        this.inputItems.fixedPhraseTitle6.value = this.inputForm.settingJson.Common.fixedPhraseTitle6;
        this.inputItems.fixedPhrase6.value = this.inputForm.settingJson.Common.fixedPhrase6;
        this.inputItems.fixedPhraseTitle7.value = this.inputForm.settingJson.Common.fixedPhraseTitle7;
        this.inputItems.fixedPhrase7.value = this.inputForm.settingJson.Common.fixedPhrase7;
        this.inputItems.fixedPhraseTitle8.value = this.inputForm.settingJson.Common.fixedPhraseTitle8;
        this.inputItems.fixedPhrase8.value = this.inputForm.settingJson.Common.fixedPhrase8;
        this.inputItems.fixedPhraseTitle9.value = this.inputForm.settingJson.Common.fixedPhraseTitle9;
        this.inputItems.fixedPhrase9.value = this.inputForm.settingJson.Common.fixedPhrase9;
        this.inputItems.fixedPhraseTitle10.value = this.inputForm.settingJson.Common.fixedPhraseTitle10;
        this.inputItems.fixedPhrase10.value = this.inputForm.settingJson.Common.fixedPhrase10;
        this.inputItems.fixedPhraseTitle11.value = this.inputForm.settingJson.Common.fixedPhraseTitle11;
        this.inputItems.fixedPhrase11.value = this.inputForm.settingJson.Common.fixedPhrase11;
        this.inputItems.fixedPhraseTitle12.value = this.inputForm.settingJson.Common.fixedPhraseTitle12;
        this.inputItems.fixedPhrase12.value = this.inputForm.settingJson.Common.fixedPhrase12;
        this.inputItems.fixedPhraseTitle13.value = this.inputForm.settingJson.Common.fixedPhraseTitle13;
        this.inputItems.fixedPhrase13.value = this.inputForm.settingJson.Common.fixedPhrase13;
        this.inputItems.fixedPhraseTitle14.value = this.inputForm.settingJson.Common.fixedPhraseTitle14;
        this.inputItems.fixedPhrase14.value = this.inputForm.settingJson.Common.fixedPhrase14;
        this.inputItems.fixedPhraseTitle15.value = this.inputForm.settingJson.Common.fixedPhraseTitle15;
        this.inputItems.fixedPhrase15.value = this.inputForm.settingJson.Common.fixedPhrase15;
        this.inputItems.fixedPhraseTitle16.value = this.inputForm.settingJson.Common.fixedPhraseTitle16;
        this.inputItems.fixedPhrase16.value = this.inputForm.settingJson.Common.fixedPhrase16;
        this.inputItems.fixedPhraseTitle17.value = this.inputForm.settingJson.Common.fixedPhraseTitle17;
        this.inputItems.fixedPhrase17.value = this.inputForm.settingJson.Common.fixedPhrase17;
        this.inputItems.fixedPhraseTitle18.value = this.inputForm.settingJson.Common.fixedPhraseTitle18;
        this.inputItems.fixedPhrase18.value = this.inputForm.settingJson.Common.fixedPhrase18;
        this.inputItems.fixedPhraseTitle19.value = this.inputForm.settingJson.Common.fixedPhraseTitle19;
        this.inputItems.fixedPhrase19.value = this.inputForm.settingJson.Common.fixedPhrase19;
        this.inputItems.fixedPhraseTitle20.value = this.inputForm.settingJson.Common.fixedPhraseTitle20;
        this.inputItems.fixedPhrase20.value = this.inputForm.settingJson.Common.fixedPhrase20;
        this.inputItems.preferredNetworkAndroid.value = this.inputForm.settingJson.Common.preferredNetworkAndroid;
        this.inputItems.preferredNetworkIOS.value = this.inputForm.settingJson.Common.preferredNetworkIOS;
        this.inputItems.resolution.value = this.inputForm.settingJson.Video.resolution;
        this.inputItems.duplicateVolume.value = this.inputForm.settingJson.Volume.duplicateVolume;
        this.inputItems.alertPeriod.value = this.inputForm.settingJson.Common.alertPeriod;
        this.inputItems.voiceReportNotifyMessage.value = this.inputForm.settingJson.Common.voiceReportNotifyMessage;
    },

    methods: {
        excludeDisabled() {
            for (let item in this.enableSwitch) {
                let categorySetting = this.inputForm.settingJson[this.enableSwitch[item].category];
                if (!this.enableSwitch[item].value) {
                    switch(item) {
                        case "reconnectSoundVolume":
                            delete categorySetting["reconnectSound"];
                            break;
                        case "alertSoundVolume":
                            delete categorySetting["alertSound"];
                            break;
                        case "reactionSoundVolume":
                            delete categorySetting["reactionSound"];
                            break;
                        case "receiveBeepVolume":
                            delete categorySetting["receiveBeep"];
                            break;
                        case "voiceVolume":
                            delete categorySetting["voice"];
                            break;
                        case "voiceOffHookVolume":
                            delete categorySetting["voiceOffHook"];
                            break;
                        case "effectSoundVolume":
                            delete categorySetting["effectSound"];
                            break;
                        case "echoSoundVolume":
                            delete categorySetting["echoSound"];
                            break;
                        case "inSpeechAlertVolume":
                            delete categorySetting["inSpeechAlertSound"];
                            break;
                        case "masterSound":
                            delete categorySetting["masterSound"];
                            break;
                        case "duplicateVolume":
                            delete categorySetting["duplicateMode"]
                            break;
                        default:
                            break;
                    }
                    delete categorySetting[item];
                }
            }
            for (let item in this.inputItems) {
                let categorySetting = this.inputForm.settingJson[this.inputItems[item].category];
                if (Array.isArray(this.inputItems[item].enable)) {
                    const allFalse = this.inputItems[item].enable.every(val => val === false);
                    if (allFalse) {
                        delete categorySetting[item];
                    }
                } else {
                    if (!this.inputItems[item].enable) {
                        if (item === "customURLAndroid") {
                            delete categorySetting.linkPackageName;
                            delete categorySetting.linkClassName;
                        }
                        delete categorySetting[item];
                    }
                }
            }
        },

        setValidStatusOfFixedPhrase(param) {
            this.inputItems[param.name].valid = param.validStatus;
            this.setButtonStatus();
        },

        setButtonStatus() {
            if (commonValidate.checkFormValidation(this.inputItems)) {
                this.disableSave = false;
            } else {
                this.disableSave = true;
            }
        },

        inputCheck(eventTargetId) {
            if ((this.inputItems[eventTargetId].isComposing) || (this.inputItems[eventTargetId].validationRule === null)) {
                // inputting with IME
                return;
            }
            let refInputItem;
            if (typeof(this.$refs[eventTargetId].length) === "undefined") {
                refInputItem = this.$refs[eventTargetId];
            } else {
                refInputItem = this.$refs[eventTargetId][0];
            }
            let validateResult = commonValidate.validateItem(this.$i18n, this.inputItems[eventTargetId].validationRule, this.inputItems[eventTargetId].value);
            if (validateResult.valid) {
                this.inputItems[eventTargetId].valid = true;

                if (this.inputItems[eventTargetId].validationRule === 'numeric') {
                    if (this.inputItems[eventTargetId].value >= this.inputItems[eventTargetId].min && this.inputItems[eventTargetId].value <= this.inputItems[eventTargetId].max) {
                        this.inputItems[eventTargetId].value = Number(this.inputItems[eventTargetId].value);
                        refInputItem.clearValidate();
                    } else {
                        this.inputItems[eventTargetId].valid = false;
                        refInputItem.validateState = "error";
                        refInputItem.validateMessage = commonUtil.getMessageText(this.$i18n, "error_validate_numeric_out_of_range").replace("{MIN}", this.inputItems[eventTargetId].min).replace("{MAX}", this.inputItems[eventTargetId].max)
                    }
                }else if (this.inputItems[eventTargetId].validationRule === 'reqText') {
                    if (this.inputItems[eventTargetId].maxLength && this.inputItems[eventTargetId].value.length <= this.inputItems[eventTargetId].maxLength) {
                        this.inputItems[eventTargetId].value = String(this.inputItems[eventTargetId].value);
                        refInputItem.clearValidate();
                    } else {
                        this.inputItems[eventTargetId].valid = false;
                        refInputItem.validateState = "error";
                        refInputItem.validateMessage = commonUtil.getMessageText(this.$i18n, "error_validate_text_too_long").replace("{MAX_LENGTH}", this.inputItems[eventTargetId].maxLength)
                    }
                } else {
                    refInputItem.clearValidate();
                }
            } else {
                this.inputItems[eventTargetId].valid = false;
                refInputItem.validateState = "error";
                refInputItem.validateMessage = validateResult.message;
            }
            this.setButtonStatus();
        },

        inputCheckCustomURLAndroid(eventTargetId) {
            if (this.inputItems.customURLAndroid.isComposing) {
                // inputting with IME
                return;
            }
            if ((eventTargetId === "customURLPackageName") || ((eventTargetId === "customURLClassName") & (!this.inputItems.customURLAndroid.valid1))) {
                let validateResult = commonValidate.validateItem(this.$i18n, "urlSchemeAndroidPackage", this.inputItems.customURLAndroid.value1);
                if (validateResult.valid) {
                    this.inputItems.customURLAndroid.valid1 = true;
                    this.$refs[eventTargetId].clearValidate();
                } else {
                    this.inputItems.customURLAndroid.valid1 = false;
                    this.$refs[eventTargetId].validateState = "error";
                    this.$refs[eventTargetId].validateMessage = validateResult.message;
                }
            }
            if ((eventTargetId === "customURLClassName") || ((eventTargetId === "customURLPackageName") & (!this.inputItems.customURLAndroid.valid2))) {
                let validateResult = commonValidate.validateItem(this.$i18n, "urlSchemeAndroidClass", this.inputItems.customURLAndroid.value2);
                if (validateResult.valid) {
                    this.inputItems.customURLAndroid.valid2 = true;
                    this.$refs[eventTargetId].clearValidate();
                } else {
                    this.inputItems.customURLAndroid.valid2 = false;
                    this.$refs[eventTargetId].validateState = "error";
                    this.$refs[eventTargetId].validateMessage = validateResult.message;
                }
            }
            this.inputItems.customURLAndroid.valid = (this.inputItems.customURLAndroid.valid1) && (this.inputItems.customURLAndroid.valid2);
            this.setButtonStatus();
        },

        inputCheckAll() {
            for (let targetId in this.inputItems) {
                if (this.inputItems[targetId].enable) {
                    if (targetId === "customURLAndroid") {
                        this.inputCheck("customURLPackageName");
                        this.inputCheck("customURLClassName");
                    } else {
                        this.inputCheck(targetId);
                    }
                }
            }
        },

        compositionStart(eventTargetId) {
            if ((eventTargetId === "customURLPackageName") || (eventTargetId === "customURLPackageName")) {
                this.inputItems.customURLAndroid.isComposing = true;
            } else {
                this.inputItems[eventTargetId].isComposing = true;
            }
        },

        compositionEnd(eventTargetId) {
            if ((eventTargetId === "customURLPackageName") || (eventTargetId === "customURLPackageName")) {
                this.inputItems.customURLAndroid.isComposing = false;
                this.inputCheckCustomURLAndroid(eventTargetId)
            } else {
                this.inputItems[eventTargetId].isComposing = false;
                this.inputCheck(eventTargetId)
            }
        },

        parseForSave() {
            this.setFixedPhraseToInputForm();
            // set input form (current value or default value)
            this.inputForm.settingName = this.inputItems.settingName.value;
            for (let item in this.inputForm.settingJson.Common) {
                switch(item) {
                    case "autoStart":
                    case "locationAcquire":
                    case "locationUpload":
                    case "iOSAudioMode":
                    case "stayAwake":
                    case "mapMode":
                    case "mapType":
                    case "bluetoothAlert":
                    case "voiceReportEnableNotify":
                    case "voiceReportShowPopup":
                    case "voiceReportSubscribeByDefault":
                        this.inputForm.settingJson.Common[item] = this.inputForm.settingJson.Common[item] ? 1 : 0;
                        break;
                    case "customURL":
                    case "subButtonMode":
                    case "subButtonLeftMode":
                    case "locationInterval":
                    case "fixedPhraseTitle1":
                    case "fixedPhraseTitle2":
                    case "fixedPhraseTitle3":
                    case "fixedPhraseTitle4":
                    case "fixedPhraseTitle5":
                    case "fixedPhraseTitle6":
                    case "fixedPhraseTitle7":
                    case "fixedPhraseTitle8":
                    case "fixedPhraseTitle9":
                    case "fixedPhraseTitle10":
                    case "fixedPhraseTitle11":
                    case "fixedPhraseTitle12":
                    case "fixedPhraseTitle13":
                    case "fixedPhraseTitle14":
                    case "fixedPhraseTitle15":
                    case "fixedPhraseTitle16":
                    case "fixedPhraseTitle17":
                    case "fixedPhraseTitle18":
                    case "fixedPhraseTitle19":
                    case "fixedPhraseTitle20":
                    case "preferredNetworkAndroid":
                    case "preferredNetworkIOS":
                    case "alertPeriod":
                    case "voiceReportNotifyMessage":
                        this.inputForm.settingJson.Common[item] = this.inputItems[item].value;
                        break;
                    case "linkPackageName":
                        this.inputForm.settingJson.Common[item] = this.inputItems.customURLAndroid.value1;
                        break;
                    case "linkClassName":
                        this.inputForm.settingJson.Common[item] = this.inputItems.customURLAndroid.value2;
                        break;
                    case "serverButtonBind":
                        this.inputItems[item].value.forEach((_, index) => {
                            if (this.inputItems[item].value[index] === "" || this.inputItems[item].value[index] === null){
                                 this.inputForm.settingJson.Common[item][index] = -1;
                            } else {
                                 this.inputForm.settingJson.Common[item][index] = this.inputItems[item].value[index];
                            }
                        });
                        break;
                    default:
                        break;
                }
            }
            for (let item in this.inputForm.settingJson.Talk) {
                switch(item) {
                    case "buttonMode":
                    case "bleButtonMode":
                    case "miniTalkButtonMode":
                    case "faceToTalkMode":
                    case "vox":
                    case "echo":
                    case "backgroundMic":
                    case "voiceProcessing":
                        this.inputForm.settingJson.Talk[item] = this.inputForm.settingJson.Talk[item] ? 1 : 0;;
                        break;
                    case "cutVoiceDelayQueueSeconds":
                        this.inputForm.settingJson.Talk[item] = this.inputItems[item].value;
                        break;
                    default:
                        break;
                }
            }
            for (let item in this.inputForm.settingJson.Chat) {
                this.inputForm.settingJson.Chat[item] = this.inputForm.settingJson.Chat[item] ? 1 : 0;
            }
            for (let item in this.inputForm.settingJson.Video) {
                this.inputForm.settingJson.Video[item] = this.inputItems[item].value;
            }

            for (let item in this.inputForm.settingJson.Volume) {
                if (item === "duplicateVolume") {
                    this.inputForm.settingJson.Volume[item] = this.inputItems[item].value;
                }
                if (item === "duplicateMode") {
                    this.inputForm.settingJson.Volume[item] = this.inputForm.settingJson.Volume[item] ? 1 : 0;
                }
                if (item === "masterSound") {
                    this.inputForm.settingJson.Volume[item] = this.inputForm.settingJson.Volume[item] ? 1 : 0;
                }
                if (item === "lockedVolume") {
                    this.inputForm.settingJson.Volume[item] = this.inputForm.settingJson.Volume[item] ? -1 : null;
                }
            }

            for (let item in this.inputForm.settingJson.Notification) {
                let currentSetting = this.clientSettingInfo.Notification[item];
                switch(item) {
                    case "notifyInForeground":
                    case "onNewTalker":
                    case "vibeOnNewTalker":
                    case "onNewMessage":
                    case "vibeOnNewMessage":
                    case "voiceNotification":
                        this.inputForm.settingJson.Notification[item] = this.inputForm.settingJson.Notification[item] ? 1 : 0;
                        break;
                    default:
                        break;
                }
            }
            this.inputForm.settingJson.Notification.vibeTypeOnNewTalker = this.inputItems.vibeTypeOnNewTalker.value;
            this.inputForm.settingJson.Notification.vibeTypeOnNewMessage = this.inputItems.vibeTypeOnNewMessage.value;
        },

        setFixedPhraseToInputForm() {
            for (let phraseIndex = 1 ; phraseIndex <= (this.fixedPhraseItemList.length / 2); phraseIndex++) {
                let editingFixedPhraseName = "fixedPhrase" + phraseIndex;
                if (this.$refs[editingFixedPhraseName][0].inputFixedPhrase.length === 0) {
                    this.inputForm.settingJson.Common[editingFixedPhraseName] = null;
                } else {
                    let fixedPhraseSettingItems = [];
                    for (let fixedPhraseSetting of this.$refs[editingFixedPhraseName][0].inputFixedPhrase) {
                        let fixedPhraseJson;
                        switch (fixedPhraseSetting.categoryValue) {
                            case constants.FIXED_PHRASE_CATEGORY_MELODY:
                                fixedPhraseJson = "MML:" + String(fixedPhraseSetting.phraseValue);
                                break;
                            case constants.FIXED_PHRASE_CATEGORY_SOUND:
                                fixedPhraseJson = "SOUND:" + fixedPhraseSetting.phraseValue;
                                break;
                            case constants.FIXED_PHRASE_CATEGORY_TEXT:
                                fixedPhraseJson = fixedPhraseSetting.phraseValue;
                                break;
                        }
                        fixedPhraseSettingItems.push(fixedPhraseJson);
                    }
                    this.inputForm.settingJson.Common[editingFixedPhraseName] = fixedPhraseSettingItems;
                    this.inputItems[editingFixedPhraseName].enable = true;
                }
            }
        },

        modifyClientSetting() {
            for (let phraseIndex = 1 ; phraseIndex <= (this.fixedPhraseItemList.length / 2); phraseIndex++) {
                let fixedPhraseItem = "fixedPhrase" + phraseIndex;
                if (this.inputItems[fixedPhraseItem].enable) {
                    if (this.$refs[fixedPhraseItem][0].inputFixedPhrase.length === 0) {
                        commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_cannot_save_fixed_phrase"));
                        return;
                    }
                    for (let actionIndex = 0 ; actionIndex < this.$refs[fixedPhraseItem][0].inputFixedPhrase.length ; actionIndex++) {
                        let inputFixedPhrase = this.$refs[fixedPhraseItem][0].inputFixedPhrase[actionIndex];
                        if (inputFixedPhrase.editMelodyStamp) {
                            this.$refs[fixedPhraseItem][0].inputCheckMelodyStamp(inputFixedPhrase);
                        }
                    }
                }
            }
            if (this.disableSave) {
                commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_cannot_save_fixed_phrase_incorrect_format"));
                return;
            }
            this.parseForSave();
            this.excludeDisabled();
            this.$emit('save', this.inputForm);
        },

        handleChangeToggleValue(category, targetId, enabled) {
            this.setButtonStatus();
        },

        handleChangeToggleFttValue(category, targetId, enabled) {
            if(this.inputForm.settingJson.Talk["faceToTalkMode"] && this.inputForm.settingJson.Talk["vox"]){
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"hint_ftt_cannot_enable"));
                this.inputForm.settingJson.Talk["faceToTalkMode"] = false;
                return;
            }
            this.setButtonStatus();
        },

        handleChangeToggleVoxValue(category, targetId, enabled) {
            if(this.inputForm.settingJson.Talk["vox"] && this.inputForm.settingJson.Talk["faceToTalkMode"]){
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"hint_vox_cannot_enable"));
                this.inputForm.settingJson.Talk["vox"] = false;
                return;
            }
            this.setButtonStatus();
        },

        handleChangeToggleSwitch(category, targetId, enabled) {
            let jsonItems;
            switch(category) {
                case "Common":
                    jsonItems = this.inputForm.settingJson.Common;
                    break;
                case "Talk":
                    jsonItems = this.inputForm.settingJson.Talk;
                    break;
                case "Chat":
                    jsonItems = this.inputForm.settingJson.Chat;
                    break;
                case "Video":
                    jsonItems = this.inputForm.settingJson.Video;
                    break;
                case "Volume":
                    jsonItems = this.inputForm.settingJson.Volume;
                    break;
                case "Notification":
                    jsonItems = this.inputForm.settingJson.Notification;
                    break;
            }
            if (enabled) {
                jsonItems[targetId] = false;
            } else {
                jsonItems[targetId] = null;
            }
            this.setButtonStatus();
        },

        handleChangeLockedVolume(enabled) {
            if (enabled) {
                this.inputForm.settingJson.Volume.lockedVolume = -1;
            } else {
                this.inputForm.settingJson.Volume.lockedVolume = null;
            }
            this.setButtonStatus();
        },

        handleChangeMasterSound(enabled) {
            if (enabled) {
                this.inputForm.settingJson.Volume.masterSound = true;
            } else {
                this.inputForm.settingJson.Volume.masterSound = null;
            }
            this.setButtonStatus();
        },

        handleChangeItems(eventTargetId) {
            if (this.inputItems[eventTargetId].validationRule === null) {
                // fixedPhrase1 to fixedPhrase10
                if (!this.inputItems[eventTargetId].enable) {
                    this.inputItems[eventTargetId].valid = true;
                }
                this.setButtonStatus();
                return;
            }
            let refInputItem;
            if (typeof(this.$refs[eventTargetId].length) === "undefined") {
                refInputItem = this.$refs[eventTargetId];
            } else {
                refInputItem = this.$refs[eventTargetId][0];
            }
            if (this.inputItems[eventTargetId].enable) {
                if (eventTargetId == "customURLAndroid") {
                    this.inputCheck("customURLPackageName");
                    this.inputCheck("customURLClassName");
                } else {
                    this.inputCheck(eventTargetId);
                }
            } else {
                if (eventTargetId == "customURLAndroid") {
                    this.inputItems[eventTargetId].value1 = null;
                    this.inputItems[eventTargetId].value2 = null;
                    this.inputItems[eventTargetId].valid1 = true;
                    this.inputItems[eventTargetId].valid2 = true;
                    this.inputItems[eventTargetId].valid = true;
                    this.$refs["customURLPackageName"].clearValidate();
                    this.$refs["customURLClassName"].clearValidate();
                } else {
                    this.inputItems[eventTargetId].value = null;
                    this.inputItems[eventTargetId].valid = true;
                    refInputItem.clearValidate();
                }
            }
            this.setButtonStatus();
        },
        handleChangeArrayItems(settingName, index) {
            let validateResult = commonValidate.validateItem(this.$i18n, this.inputItems[settingName].validationRule, this.inputItems[settingName].value[index]);
            const refKey = `${settingName}${index + 1}`;
            let refItem = this.$refs[refKey];
            if (Array.isArray(refItem)) {
                refItem = refItem[0];
            }

            if (validateResult.valid) {
                this.inputItems[settingName].valid[index] = true;
                if (refItem && typeof refItem.clearValidate === 'function') {
                    refItem.clearValidate();
                }
            } else {
                this.inputItems[settingName].valid[index] = false;
                refItem.validateState = "error";
                refItem.validateMessage = validateResult.message;
            }
            if (!(this.inputItems[settingName].enable[index])) {
                this.inputItems[settingName].value[index] = null;
                this.inputItems[settingName].valid[index] = true;
                refItem.clearValidate();
            }
            this.setButtonStatus();
        },

        handleChangeReconnectVolume() {
            if (!this.enableSwitch.reconnectSoundVolume.value) {
                this.inputForm.settingJson.Volume.reconnectSoundVolume = 0;
            }
            this.setButtonStatus();
        },

        handleChangeAlertSoundVolume() {
            if (!this.enableSwitch.alertSoundVolume.value) {
                this.inputForm.settingJson.Volume.alertSoundVolume = 0;
            }
            this.setButtonStatus();
        },

        handleChangeReactionVolume() {
            if (!this.enableSwitch.reactionSoundVolume.value) {
                this.inputForm.settingJson.Volume.reactionSoundVolume = 0;
            }
            this.setButtonStatus();
        },

        handleChangeDuplicateVolume(targetItem) {
            if (this.enableSwitch.duplicateVolume.value) {
                this.inputCheck(targetItem);
                this.inputItems.duplicateVolume.enable = true
            } else {
                this.inputItems[targetItem].value = null;
                this.inputItems[targetItem].valid = true;
                this.inputForm.settingJson.Volume.duplicateVolume = 0;
                this.inputItems.duplicateVolume.enable = false
                this.$refs[targetItem].clearValidate();
            }
            this.setButtonStatus();
        },

        handleChangeVolume(targetItem) {
            if (!this.enableSwitch[targetItem].value) {
                this.inputForm.settingJson.Volume[targetItem] = 0;
            }
            this.setButtonStatus();
        },

        handleChangeToggleValue_Bit(category, targetId, targetBitId ,value){
            let jsonItems;
            switch (category) {
                case "Common":
                    jsonItems = this.inputForm.settingJson.Common;
                    break;
                case "Talk":
                    jsonItems = this.inputForm.settingJson.Talk;
                    break;
                case "Chat":
                    jsonItems = this.inputForm.settingJson.Chat;
                    break;
                case "Video":
                    jsonItems = this.inputForm.settingJson.Video;
                    break;
                case "Volume":
                    jsonItems = this.inputForm.settingJson.Volume;
                    break;
                case "Notification":
                    jsonItems = this.inputForm.settingJson.Notification;
                    break;
            }
            if (this.bitStatus[targetId][targetBitId]) {
                jsonItems[targetId] |= value;
            } else {
                jsonItems[targetId] &= ~value;
            }
            this.setButtonStatus();
        },

        handleChangeToggleSwitch_Bit(category, targetId, enabled) {
            let jsonItems;
            let targetBitIds = this.bitStatus[targetId]
            switch(category) {
                case "Common":
                    jsonItems = this.inputForm.settingJson.Common;
                    break;
                case "Talk":
                    jsonItems = this.inputForm.settingJson.Talk;
                    break;
                case "Chat":
                    jsonItems = this.inputForm.settingJson.Chat;
                    break;
                case "Video":
                    jsonItems = this.inputForm.settingJson.Video;
                    break;
                case "Volume":
                    jsonItems = this.inputForm.settingJson.Volume;
                    break;
                case "Notification":
                    jsonItems = this.inputForm.settingJson.Notification;
                    break;
            }
            if (enabled) {
                jsonItems[targetId] = 0;
                for (const targetBitId in targetBitIds) {
                    this.bitStatus[targetId][targetBitId] = false;
                };
            } else {
                jsonItems[targetId] = null;
                for (const targetBitId in targetBitIds) {
                    this.bitStatus[targetId][targetBitId] = null;
                };
            }
            this.setButtonStatus();
        },

        handleInputText(eventTargetId){
            if(!this.inputItems[eventTargetId] || !this.$refs[eventTargetId]){
                return;
            }

            if (this.inputItems[eventTargetId].enable) {
                this.inputCheck(eventTargetId);
            } else {
                this.inputItems[eventTargetId].value = null;
                this.inputItems[eventTargetId].valid = true;
                this.$refs[eventTargetId]?.clearValidate();
            }

            this.setButtonStatus();
        },

        enableDisconnectAlertGroup() {
            return (this.tenantOption & constants.DISCONNECT_ALERT_GROUP);
        }
    },
}
</script>

<style scoped>
.dialog-body-setting {
    height: calc(90vh - 180px);
    padding: 0;
    font-size: 14px;
    overflow: auto;
    padding: 20px;
}
.setting-switch {
    text-align: right;
    padding-right: 20px;
}
.setting-switch-header {
    text-align: right;
    padding-right: 20px;
    color: #848991;
    font-size: 12px;
}
.enableSwitch {
    margin-bottom: 22px;
    padding-left: 20px;
}
.setting-items {
}
.setting-items >>> .el-slider__button {
    width: 12px;
    height: 12px;
    background-color: #5171cb;
    border: #5171cb;
}
.disable-setting-items >>> .el-slider__button {
    width: 12px;
    height: 12px;
    background-color: #c0c4cc;
    border: #c0c4cc;
}

.setting-items >>> .el-slider__bar {
    background-color: #5171cb;
}

.setting-items >>> .el-radio__input.is-checked .el-radio__inner {
    background: #5171cb;
}
.setting-items >>> .el-radio__input.is-checked+.el-radio__label {
    color: #5171cb;
}
.setting-items >>> .el-radio__input.is-disabled .el-radio__inner, .el-radio__input.is-disabled.is-checked .el-radio__inner {
    background: #f5f7fa;
}

.custom-url >>> .el-input-group__prepend {
    width: 100px;
}

.el-select {
    width: 300px;
}

.setting-name-1 {
    padding-left: 20px;
    padding-top:20px;
    vertical-align:top;
}
.setting-name-2 {
    padding-left: 20px;
    padding-top:10px;
    vertical-align:top;
}
.setting-value {
    padding-left: 20px;
    max-width:500px
}
</style>
